// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:22.119Z
// Property: Cypress Crossing (ID: 6767906449165603)
// Collections: 27 amenities, 13 floorplans (live), 64 photos, 68 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165603",
  "property_external_id": "ktbye5c",
  "property_zillow_url": "https://www.zillow.com/apartments/owasso-ok/cypress-crossing/CmfCLx/",
  "property_apartments_url": "https://www.apartments.com/cypress-crossing-owasso-ok/ktbye5c/",
  "property_google_business_url": "https://www.google.com/maps/place/Cypress+Crossing/data=!4m2!3m1!1s0x0:0x2d83327fabdf935d?sa=X&ved=2ahUKEwib7JjL-LySAxXZRTABHfCWO-YQ_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cypress-crossing",
  "property_name": "Cypress Crossing",
  "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/cypress-crossing/",
  "property_domain": null,
  "property_address": "10015 N. Owasso Expressway",
  "property_full_address": "10015 N. Owasso Expressway, Owasso, OK, 74055",
  "property_address_1": "10015 N. Owasso Expressway",
  "property_address_2": null,
  "property_address_city": "Owasso",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74055",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "North Tulsa",
  "property_address_latitude": "36.2989",
  "property_address_longitude": "-95.8229",
  "property_email": "cypresscrossing@caseusa.com",
  "property_phone": "(539) 212-3987",
  "property_call_tracking_phone": "888-569-2758",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cypress Crossing in Owasso, Oklahoma—a vibrant community where comfort meets style. Choose from spacious one, two, or three-bedroom floor plans, equipped with modern amenities like a refreshing pool, fitness center, and dog park. Don’t miss the chance to experience your ideal lifestyle—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Cypress Crossing: Your Ideal Apartment Community in Owasso, Oklahoma**\n\nDiscover the perfect blend of comfort and style at Cypress Crossing, a premier apartment community that offers a variety of spacious floor plans to fit your lifestyle. Choose from our elegant one, two, or three-bedroom apartments, designed with your convenience in mind. Each apartment features modern amenities, including stainless steel appliances, walk-in closets, air conditioning, and high-speed internet access, ensuring you have everything you need to feel right at home.\n\nAt Cypress Crossing, we believe in providing a community that enhances your living experience. Enjoy our resort-style pool, perfect for relaxing on sunny days, and a state-of-the-art fitness center to keep your health on track. For those who love to socialize, our clubhouse is the ideal spot for gatherings, while our picnic area with grills invites you to enjoy outdoor meals with friends and family. Plus, our well-maintained gated community offers peace of mind with on-site management and 24-hour access.\n\nPet owners will appreciate our dedicated dog park, and for those working from home, a fully equipped business center is available. The convenience of package service and online services adds to the ease of living at Cypress Crossing.\n\nLocated in the heart of Owasso, Oklahoma, you’ll have quick access to shopping, dining, and entertainment options. \n\nDon’t miss out on finding your new home! Browse our availability or schedule a tour today to explore the Cypress Crossing community and discover why our residents love living here. Your ideal apartment lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3e-c2cc-743e-8515-781515a1357e.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool with lounge chairs and modern apartment buildings in the background.",
    "public_id": "019cfb3e-c2cc-743e-8515-781515a1357e",
    "storage_key": "property/6767906449165603/019cfb3e-c2cc-743e-8515-781515a1357e.webp",
    "width": 3072,
    "height": 2047
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "366",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.44808743169399",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Dogs and cats allowed. Maximum of two pets per unit.",
  "property_pet_policy_description": "Dogs and cats allowed. Maximum of two pets per unit. One-time pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cypresscrossingapartmentsowasso.securecafe.com/onlineleasing/cypress-crossing/floorplans.aspx",
  "property_resident_portal_url": "https://cypresscrossingapartmentsowasso.securecafenet.com/residentservices/cypress-crossing/userlogin",
  "property_apply_now_url": "https://cypresscrossingapartmentsowasso.securecafe.com/onlineleasing/cypress-crossing/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-855c-7037-b4a0-60a267a7fd7f.webp",
  "property_primary_logo_media": {
    "alt_text": "Cypress Crossing Luxury Apartments logo with a teal tree and white text.",
    "public_id": "019cfb3f-855c-7037-b4a0-60a267a7fd7f",
    "storage_key": "property/6767906449165603/019cfb3f-855c-7037-b4a0-60a267a7fd7f.webp",
    "width": 2401,
    "height": 2100
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb41-54b8-72ef-a88d-f39c61c6b096.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb41-54b8-72ef-a88d-f39c61c6b096",
    "storage_key": "property/6767906449165603/019cfb41-54b8-72ef-a88d-f39c61c6b096.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb41-6d73-7171-864f-f5e82ea27ea9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cypress Crossing Luxury Apartments logo",
    "public_id": "019cfb41-6d73-7171-864f-f5e82ea27ea9",
    "storage_key": "property/6767906449165603/019cfb41-6d73-7171-864f-f5e82ea27ea9.webp",
    "width": 640,
    "height": 560
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb41-768f-7148-a14f-82576e67d5fe.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cypress Crossing Luxury Apartments logo with a silhouette of a cypress tree.",
    "public_id": "019cfb41-768f-7148-a14f-82576e67d5fe",
    "storage_key": "property/6767906449165603/019cfb41-768f-7148-a14f-82576e67d5fe.webp",
    "width": 640,
    "height": 560
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#00aca0",
  "property_secondary_color": "#53575a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1412",
  "property_sqft_min": "789",
  "property_sqft_max": "1412",
  "property_price_range": "1204 - 2069",
  "property_price_min": "1204",
  "property_price_max": "2069",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/CypressCrossingAptsOwasso/posts/discover-your-new-home-at-cypress-crossing-in-owasso-visit-our-website-to-learn-/122138144402691565/",
  "property_instagram_url": "https://www.instagram.com/cypresscrossingapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3xtgpRv7tocRXZPfq38ygy0",
  "property_youtube_url": "https://www.youtube.com/watch?v=HAtnpBLxkWc",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Owasso%2C+OK+74055",
  "property_tiktok_url": "https://www.tiktok.com/@cypress.crossing",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cypress Crossing",
  "property_home_romance_title": "Embrace Your New Beginning in Our Charming Community",
  "property_home_amenities_blurb": "At Cypress Crossing in Owasso, Oklahoma, your ideal lifestyle awaits! Choose from stylish one, two, or three-bedroom floor plans that blend comfort and modern elegance. Enjoy our resort-style pool, a state-of-the-art fitness center, and a welcoming clubhouse—all designed for your relaxation and enjoyment. Experience community living redefined!",
  "property_home_floorplans_blurb": "At Cypress Crossing in Owasso, Oklahoma, your ideal living space awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans that blend comfort and style. Ready to elevate your lifestyle? Browse our available apartment homes and find the perfect fit for you today!",
  "property_home_gallery_blurb": "Welcome to Cypress Crossing, where your ideal lifestyle awaits in Owasso, Oklahoma. Choose from spacious one, two, or three-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and dog park. Picture yourself enjoying a sunny day on your private balcony or grilling in our picnic area!",
  "property_home_neighborhood_blurb": "At Cypress Crossing in Owasso, Oklahoma, your ideal living space awaits—choose from one, two, or three-bedroom floor plans that cater to your lifestyle. Beyond your doorstep, enjoy a vibrant community with parks, enriching local attractions like the Owasso Library, and opportunities for adventure at Airtopia Adventure Park. Embrace comfort and convenience!",
  "property_home_reviews_blurb": "Welcome to Cypress Crossing, where our residents thrive in a supportive and beautiful environment. With a five-star rating, newcomers appreciate the \"terrific\" staff and transparent assistance. Enjoy quick maintenance solutions and indulge in our inviting pool and fitness areas. Join a community where connections flourish!  See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Owasso, Cypress Crossing offers easy access to vibrant community gems like the Owasso Library, Airtopia Adventure Park, and relaxing parks such as Centennial and Rayola. Enjoy the perfect blend of comfort and convenience while immersing yourself in the rich array of activities and landmarks nearby.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cypress Crossing in Owasso, Oklahoma, your comfort meets convenience. Indulge in our inviting pool, state-of-the-art fitness center, and vibrant clubhouse. With spacious one to three-bedroom floor plans and top-notch features like stainless steel appliances and a dog park, your perfect home awaits. Come see what makes us unique!",
  "property_applynow_blurb": "At Cypress Crossing in Owasso, Oklahoma, your dream apartment awaits! Choose from stylish one, two, or three-bedroom floor plans adorned with modern amenities. Dive into a vibrant lifestyle featuring a sparkling pool, fitness center, dog park, and more. Ready to make the leap? Lease online today for your new home!",
  "property_contactus_blurb": "At Cypress Crossing in Owasso, Oklahoma, our thoughtfully designed one, two, and three-bedroom apartments offer comfort and style for every lifestyle. Ready to find your perfect space? Our friendly leasing team is here to assist you. Have questions? Reach out today to start your journey to exceptional living!",
  "property_faqs_blurb": "At Cypress Crossing in Owasso, Oklahoma, we offer spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Curious about community amenities or lease terms? Navigate to our FAQs page for insights that will help you make the best choice for your new home. Your perfect space awaits!",
  "property_floorplans_blurb": "At Cypress Crossing in Owasso, Oklahoma, find the perfect sanctuary tailored to your lifestyle. Whether you seek a cozy one-bedroom, a spacious two-bedroom, or a vibrant three-bedroom layout, we offer a variety of thoughtfully designed floor plans. Browse our available apartment homes and envision your future today!",
  "property_gallery_blurb": "At Cypress Crossing in Owasso, Oklahoma, your ideal lifestyle awaits. From stunning one to three-bedroom floor plans to amenities like a refreshing pool, fitness center, and a vibrant dog park, your dream home is just a click away. Picture yourself relaxing on the sundeck or enjoying a barbecue with friends.",
  "property_interactivemap_blurb": "At Cypress Crossing in Owasso, Oklahoma, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like high-speed internet and walk-in closets. Utilize our interactive community map to find your ideal apartment and explore the vibrant lifestyle that extends beyond your door!",
  "property_pets_blurb": "At Cypress Crossing in Owasso, OK, your furry friends are part of the family! Enjoy spacious living with the comfort of two pets allowed in each home. With a one-time pet fee and affordable monthly rent, your pets will thrive as much as you do in our vibrant community.",
  "property_referafriend_blurb": "At Cypress Crossing in Owasso, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Share the joy of exceptional living—great friends make great neighbors! Refer a friend to our vibrant community today and enjoy the benefits of a shared home experience.",
  "property_residentaccess_blurb": "Welcome to Cypress Crossing in Owasso, Oklahoma, where comfort meets convenience! Whether you prefer a cozy one-bedroom or a spacious three-bedroom layout, our floor plans cater to every lifestyle. Access your resident portal now to effortlessly pay rent, schedule maintenance, and enjoy seamless living. Your home awaits!",
  "property_reviews_blurb": "At Cypress Crossing in Owasso, Oklahoma, our residents wholeheartedly embrace the vibrant community spirit! As one satisfied neighbor notes, “The staff are terrific... the move-in process was easy.” Join us in enjoying our beautiful grounds, refreshing pool, and state-of-the-art fitness areas. See what our residents have to say about living at our community!",
  "property_created_at": "1753982383744",
  "property_scheduletour_blurb": "At Cypress Crossing in Owasso, Oklahoma, we offer a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Experience comfort and community—schedule your tour today and hear firsthand why our residents love calling Cypress Crossing their home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Cypress Crossing in Owasso, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Our community is ready to welcome you home—stay tuned for a prompt response from our team to help you find the perfect fit!",
  "property_virtualtours_blurb": "Welcome to Cypress Crossing in Owasso, Oklahoma, where spacious living meets modern comfort. Choose from stylish one, two, or three-bedroom floor plans designed to enhance your lifestyle. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Cypress Crossing",
  "property_seo_title_home": "Cypress Crossing |  Apartments in Owasso, Oklahoma",
  "property_seo_description_home": "Experience luxury living at Cypress Crossing in Owasso! Enjoy spacious floor plans, a resort-style pool, and pet-friendly amenities. Your dream home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Owasso, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cypress Crossing in Owasso, OK. From cozy one-bedrooms to spacious three-bedrooms, our diverse floor plans cater to your lifestyle.",
  "property_seo_title_amenities": "Amenities | Owasso, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Cypress Crossing in Owasso, OK! Enjoy a pool, fitness center, dog park, and stylish apartments. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Owasso, Oklahoma",
  "property_seo_description_gallery": "Experience Cypress Crossing in Owasso, OK—stunning floor plans, exceptional amenities, and a vibrant community await your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Cypress Crossing Apartments",
  "property_seo_description_virtualtours": "Step inside Cypress Crossing in Owasso, OK! Enjoy our spacious one, two, and three-bedroom apartments. Take a virtual tour today and find your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | Cypress Crossing Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Cypress Crossing in Owasso, OK! Utilize our interactive map to explore one, two, or three-bedroom apartments with unbeatable amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Owasso, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Owasso at Cypress Crossing. Dive into nearby favorites and vibrant local spots just steps from your one, two, or three-bedroom home!",
  "property_seo_title_contact": "Contact Us | Cypress Crossing",
  "property_seo_description_contact": "Connect with Cypress Crossing in Owasso, OK! From cozy one-beds to spacious three-beds, our leasing team is ready to answer your questions—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Owasso, Oklahoma",
  "property_seo_description_faqs": "Get the answers you need! Visit Cypress Crossing's FAQs for insights on our amenities, floor plans, and living in Owasso. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Owasso, Oklahoma",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Cypress Crossing in Owasso! Explore resident reviews, amenities, spacious floor plans, and our welcoming community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Owasso, Oklahoma",
  "property_seo_description_applynow": "Discover luxury at Cypress Crossing in Owasso! Choose from one to three-bedroom floor plans with amazing amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Cypress Crossing",
  "property_seo_description_residentaccess": "Seamlessly manage your Cypress Crossing home from Owasso! Log in to access rent payment, maintenance requests, and exclusive resident services today!",
  "property_seo_title_referafriend": "Refer A Friend | Cypress Crossing",
  "property_seo_description_referafriend": "Refer a friend to Cypress Crossing in Owasso, OK! Great friends make great neighbors—share the joy of living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cypress Crossing",
  "property_seo_description_scheduletour": "Experience the charm of Cypress Crossing in Owasso, OK—where modern living meets community spirit. Schedule your tour today and find your perfect home!",
  "property_seo_title_privacy": "Privacy Policy | Cypress Crossing",
  "property_seo_description_privacy": "At Cypress Crossing in Owasso, transparency matters. Dive into our privacy policy to learn how we protect your personal information with care and integrity.",
  "property_seo_title_accessibility": "Website Accessibility | Cypress Crossing",
  "property_seo_description_accessibility": "At Cypress Crossing in Owasso, we prioritize accessibility for everyone. Join us in creating an inclusive community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Cypress Crossing",
  "property_seo_description_sitemap": "Navigate your way to luxury living at Cypress Crossing in Owasso, OK! Uncover all our amenities and community features effortlessly with our sitemap.",
  "property_seo_title_thankyou": "Thank You | Cypress Crossing",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to exquisite living at Cypress Crossing in Owasso begins here. Expect a prompt reply from our friendly team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Owasso, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865205671",
  "amenities": [
    {
      "id": "ec_7ba061cc213a78cc372dd29f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396554",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68fa23a67ff1bc1a6d79e2ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396558",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94bd154e284cd253197b5c43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396559",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a7bb983768859585354c635",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396560",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af0d9e63f81e19090afe6c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396561",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9282d3aacf64466055e05999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396562",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04547b0cad3e8b752811963b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396563",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b740545e7560f1efc873e1c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396564",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76459e1fc12f78e57905c4c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396565",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abda7b031b4fcfef65ce37d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396566",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_271ad8d5fb9942341ae87ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396567",
      "title": "Poolside Grill and Chill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dfde84b6d94b3b17234f3bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396568",
      "title": "Picnic Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88667b4dfa4ed92be3c276d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127396569",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2502e1f3f299f4540f3018dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "128017319",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bad0157a6ccf5d1ae4cdc6db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "128042531",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d89fd49627cb2be097c17a4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398034",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f98773f93620d84f3d9a874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398036",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f69f80f444a2653e7eeee3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398037",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0619861972e579c67187606d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398038",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2195d4a1431f2b2d41cb6de4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398039",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab68747c42c24f7129e9c0c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398040",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d5533f439b765a759ae7818",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398041",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64b0f74be33b8b726713b375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398042",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18fc042170aee2da3803b46c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398043",
      "title": "Energy Efficient Stainless Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c870f10177e1de2e265e802",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398044",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c8612f3519989153d3bebb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398045",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f83c9f8db14b6f7fe177b7d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "yardi",
      "external_id": "127398046",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d17a0a10-42df-4a03-b2dc-69ae097f9058",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-338d-714d-a502-49bc0b81f3af.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and breakfast bar with leather stools.",
        "public_id": "019e1cd4-338d-714d-a502-49bc0b81f3af",
        "storage_key": "property/6767906449165603/019e1cd4-338d-714d-a502-49bc0b81f3af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen, featuring granite countertops, stainless steel appliances, and a convenient breakfast bar.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and breakfast bar with leather stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b02b6240-0581-436d-b784-967f653793d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-21f9-741c-8dad-db949e87ee0a.webp",
      "image_media": {
        "alt_text": "Interior of a modern living room with a brown leather sofa, throw pillows, and a coffee table with a candle.",
        "public_id": "019e1cd4-21f9-741c-8dad-db949e87ee0a",
        "storage_key": "property/6767906449165603/019e1cd4-21f9-741c-8dad-db949e87ee0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a stylish leather sofa, plush throw pillows, and elegant side tables with lamps.",
      "link": "",
      "alt_text": "Interior of a modern living room with a brown leather sofa, throw pillows, and a coffee table with a candle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68282b8b-558c-4fa3-948d-0a08794c0a81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-3628-768d-8ed7-cd0e96786f3b.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, modern light fixture, and dark wood cabinets. Toilet visible.",
        "public_id": "019e1cd4-3628-768d-8ed7-cd0e96786f3b",
        "storage_key": "property/6767906449165603/019e1cd4-3628-768d-8ed7-cd0e96786f3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a single vanity with a marble-look countertop, undermount sink, and dark wood cabinetry. A contemporary light fixture illuminates the space, and a toilet is visible to the right.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, modern light fixture, and dark wood cabinets. Toilet visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ddf5086-d15b-41cd-98bc-be9e4cadc6c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ec81-73e8-ba20-ac55f3aa1b5e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white ruffled shower curtain, toilet, and cabinet.",
        "public_id": "019e1cd3-ec81-73e8-ba20-ac55f3aa1b5e",
        "storage_key": "property/6767906449165603/019e1cd3-ec81-73e8-ba20-ac55f3aa1b5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this chic apartment bathroom, featuring a stylish ruffled shower curtain, a modern vanity, and tasteful wall art.",
      "link": "",
      "alt_text": "Modern bathroom with a white ruffled shower curtain, toilet, and cabinet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c4041e8-be21-4f0e-9652-6b22004dc19e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-3383-745d-b33c-62484f7a5064.webp",
      "image_media": {
        "alt_text": "Modern bathroom with toilet, shower, and vanity",
        "public_id": "019e1cd4-3383-745d-b33c-62484f7a5064",
        "storage_key": "property/6767906449165603/019e1cd4-3383-745d-b33c-62484f7a5064.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bathroom featuring a modern toilet, a deep soaking tub with a shower, and ample storage with overhead cabinets.",
      "link": "",
      "alt_text": "Modern bathroom with toilet, shower, and vanity",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d732719c-6257-4855-879e-9f16e6f0b606",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-2970-71a8-989c-6af4b638297a.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "019e1cd4-2970-71a8-989c-6af4b638297a",
        "storage_key": "property/6767906449165603/019e1cd4-2970-71a8-989c-6af4b638297a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample white wire shelving for storage.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89749377-87c3-4247-a0cc-c63399c0a717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-1c8a-700d-89d7-38dca9c7d68d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with white curtain.",
        "public_id": "019e1cd4-1c8a-700d-89d7-38dca9c7d68d",
        "storage_key": "property/6767906449165603/019e1cd4-1c8a-700d-89d7-38dca9c7d68d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and modern bathroom, featuring a spacious vanity with a marble countertop, a large mirror, and a shower with a white curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a10ea5d8-81e5-4d8e-9a45-ead123bfc72e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ebd5-7470-a4f5-09387871bb9d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity and a large mirror reflecting a light fixture and wall decor.",
        "public_id": "019e1cd3-ebd5-7470-a4f5-09387871bb9d",
        "storage_key": "property/6767906449165603/019e1cd3-ebd5-7470-a4f5-09387871bb9d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy bathroom featuring a clean vanity with a modern faucet, a large mirror, and decorative wall art.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity and a large mirror reflecting a light fixture and wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4afec404-00eb-4a90-8ecf-a9fc381e9219",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-19e0-74b2-a5ff-4dbf23e026b5.webp",
      "image_media": {
        "alt_text": "A modern bathroom with a marble vanity, toilet, and bathtub with a white shower curtain.",
        "public_id": "019e1cd4-19e0-74b2-a5ff-4dbf23e026b5",
        "storage_key": "property/6767906449165603/019e1cd4-19e0-74b2-a5ff-4dbf23e026b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the comfort and convenience of this well-appointed apartment bathroom, featuring a spacious vanity, modern fixtures, and a relaxing bathtub.",
      "link": "",
      "alt_text": "A modern bathroom with a marble vanity, toilet, and bathtub with a white shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d30d3eb4-8a1d-447b-a6e9-8b000796e263",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd4-0758-7113-8387-6b3a60bf7291.webp",
      "image_media": {
        "alt_text": "Living room with a curved sofa, coffee table, and large windows.",
        "public_id": "019e1cd4-0758-7113-8387-6b3a60bf7291",
        "storage_key": "property/6767906449165603/019e1cd4-0758-7113-8387-6b3a60bf7291.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable curved sofa, a chic coffee table, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room with a curved sofa, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43299b58-5566-445c-a7a1-4807fc1a1b7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ed5b-7179-99f4-32fce1fc93df.webp",
      "image_media": {
        "alt_text": "View of a bathroom with orchids and a marble countertop.",
        "public_id": "019e1cd3-ed5b-7179-99f4-32fce1fc93df",
        "storage_key": "property/6767906449165603/019e1cd3-ed5b-7179-99f4-32fce1fc93df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring orchids, a marble countertop, and storage solutions.",
      "link": "",
      "alt_text": "View of a bathroom with orchids and a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eba14979-4556-4a62-88ee-119887344e4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ee7b-71ee-b90d-b643edc2189c.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a king-size bed, wooden furniture, and pink curtains.",
        "public_id": "019e1cd3-ee7b-71ee-b90d-b643edc2189c",
        "storage_key": "property/6767906449165603/019e1cd3-ee7b-71ee-b90d-b643edc2189c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a plush king-size bed, stylish wooden furniture, and elegant pink drapes. A perfect retreat for relaxation.",
      "link": "",
      "alt_text": "A cozy bedroom with a king-size bed, wooden furniture, and pink curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_185182da-d663-4a1c-8cbd-1f8ba97adeb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ec82-72a1-be2a-c7740398e4f9.webp",
      "image_media": {
        "alt_text": "Kitchen with white subway tile backsplash, gray cabinets, and stainless steel appliances.",
        "public_id": "019e1cd3-ec82-72a1-be2a-c7740398e4f9",
        "storage_key": "property/6767906449165603/019e1cd3-ec82-72a1-be2a-c7740398e4f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring gray cabinetry, white subway tile backsplash, and stainless steel appliances, including a microwave and oven.",
      "link": "",
      "alt_text": "Kitchen with white subway tile backsplash, gray cabinets, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de0be727-3534-4c15-92b3-39b04d9bcf81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-ec26-723d-9093-e5bcdcdcb192.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, chairs, coffee table, dining table, and artwork.",
        "public_id": "019e1cd3-ec26-723d-9093-e5bcdcdcb192",
        "storage_key": "property/6767906449165603/019e1cd3-ec26-723d-9093-e5bcdcdcb192.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a modern sofa, accent chairs, a coffee table, and a small dining area, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, chairs, coffee table, dining table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a05ba5d-4f1b-43f3-a5d7-dd1ffce2ca0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-b9ea-762e-b2ea-7cad528d7496.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019e1cd2-b9ea-762e-b2ea-7cad528d7496",
        "storage_key": "property/6767906449165603/019e1cd2-b9ea-762e-b2ea-7cad528d7496.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring white cabinetry, sleek stainless steel appliances, and elegant marble countertops, perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31866fb6-95e6-4d67-9d6a-eae1737a178a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-2cfc-7266-8bbc-dae7693aa0c0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, and stainless steel appliances.",
        "public_id": "019e1cd3-2cfc-7266-8bbc-dae7693aa0c0",
        "storage_key": "property/6767906449165603/019e1cd3-2cfc-7266-8bbc-dae7693aa0c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring dark wood cabinetry, a marble-look countertop, and stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, white subway tile backsplash, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_192be73a-f688-4b4d-b690-1d77d95f625d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-362f-7435-90e9-650adfe4712c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
        "public_id": "019e1cd3-362f-7435-90e9-650adfe4712c",
        "storage_key": "property/6767906449165603/019e1cd3-362f-7435-90e9-650adfe4712c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable queen-size bed, two elegant nightstands with lamps, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ab712a6-60b7-4682-865d-daf4b8b28f31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-3c2f-734e-a475-1f471c80312f.webp",
      "image_media": {
        "alt_text": "Living room and dining area in an apartment with a sofa, armchair, dining table, and large artwork.",
        "public_id": "019e1cd3-3c2f-734e-a475-1f471c80312f",
        "storage_key": "property/6767906449165603/019e1cd3-3c2f-734e-a475-1f471c80312f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and stylish living area perfect for relaxing and entertaining. This open-concept space features comfortable seating, a dining nook, and beautiful decor.",
      "link": "",
      "alt_text": "Living room and dining area in an apartment with a sofa, armchair, dining table, and large artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2938eff-5bfa-410e-9d3b-aa911543c255",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-0996-708e-bedb-a7c25afbde32.webp",
      "image_media": {
        "alt_text": "Modern dining area with a table and chairs, adjacent to a desk and artwork.",
        "public_id": "019e1cd3-0996-708e-bedb-a7c25afbde32",
        "storage_key": "property/6767906449165603/019e1cd3-0996-708e-bedb-a7c25afbde32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining area perfect for meals or work, complemented by a modern desk and captivating art.",
      "link": "",
      "alt_text": "Modern dining area with a table and chairs, adjacent to a desk and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_787cd819-4a7f-4048-853d-0bbd1b66d4f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-278b-767d-adc1-28da5f1b140e.webp",
      "image_media": {
        "alt_text": "Stylish dining and work area with a wooden table set for four and a chic desk with a green chair.",
        "public_id": "019e1cd3-278b-767d-adc1-28da5f1b140e",
        "storage_key": "property/6767906449165603/019e1cd3-278b-767d-adc1-28da5f1b140e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience a blend of comfort and style in this versatile space, featuring a charming dining area and a functional workspace perfect for productivity.",
      "link": "",
      "alt_text": "Stylish dining and work area with a wooden table set for four and a chic desk with a green chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_776b9bde-d7cc-40ab-a969-bbbea6ffab31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-2d81-77bd-966a-f517d528ab89.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, subway tile backsplash, and wood cabinetry.",
        "public_id": "019e1cd3-2d81-77bd-966a-f517d528ab89",
        "storage_key": "property/6767906449165603/019e1cd3-2d81-77bd-966a-f517d528ab89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring ample cabinet space, sleek countertops, and a full suite of stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, subway tile backsplash, and wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c1aa97c-48ea-4a79-bf8a-dee9a975280c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-0e32-7189-9a3c-050115bd063e.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstand, and dresser.",
        "public_id": "019e1cd3-0e32-7189-9a3c-050115bd063e",
        "storage_key": "property/6767906449165603/019e1cd3-0e32-7189-9a3c-050115bd063e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a stylish nightstand, and a large dresser.",
      "link": "",
      "alt_text": "Bedroom with queen bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f873e11-cd7a-4818-a0bd-f3a024eb2af8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-06b7-70dc-abe2-a9de6c4378ae.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and large windows.",
        "public_id": "019e1cd3-06b7-70dc-abe2-a9de6c4378ae",
        "storage_key": "property/6767906449165603/019e1cd3-06b7-70dc-abe2-a9de6c4378ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable king-size bed, elegant dresser, and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ecd3767e-2f1d-4d45-a71c-a7125cd1b336",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd3-0813-701f-ab4e-93df5335503a.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace and television.",
        "public_id": "019e1cd3-0813-701f-ab4e-93df5335503a",
        "storage_key": "property/6767906449165603/019e1cd3-0813-701f-ab4e-93df5335503a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a sleek fireplace, mounted television, and comfortable seating.",
      "link": "",
      "alt_text": "Modern living room with a fireplace and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac7e3855-7caf-428d-ac5b-219353529232",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-e2ea-72ce-bf2a-6faf04cb3d41.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets, open to a living area.",
        "public_id": "019e1cd2-e2ea-72ce-bf2a-6faf04cb3d41",
        "storage_key": "property/6767906449165603/019e1cd2-e2ea-72ce-bf2a-6faf04cb3d41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar, seamlessly flowing into a spacious living and dining area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets, open to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e77fdf7-b63b-416a-ac54-caeabf2211b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-fa92-7549-a7a0-07625940f842.webp",
      "image_media": {
        "alt_text": "A primary bedroom with a king-size bed, nightstands, a dresser, and a large mirror.",
        "public_id": "019e1cd2-fa92-7549-a7a0-07625940f842",
        "storage_key": "property/6767906449165603/019e1cd2-fa92-7549-a7a0-07625940f842.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed primary bedroom, featuring a comfortable king-size bed, elegant nightstands, and a spacious dresser for all your storage needs.",
      "link": "",
      "alt_text": "A primary bedroom with a king-size bed, nightstands, a dresser, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9de89241-adc3-40ea-8f4b-fc5e9c49582e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-efc5-75fa-b3a7-3f9bab1b6dc7.webp",
      "image_media": {
        "alt_text": "Living room with leather sofa, coffee table, desk, and accent chair.",
        "public_id": "019e1cd2-efc5-75fa-b3a7-3f9bab1b6dc7",
        "storage_key": "property/6767906449165603/019e1cd2-efc5-75fa-b3a7-3f9bab1b6dc7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully decorated living room featuring a comfortable leather sofa, stylish coffee table, a functional desk area, and an inviting accent chair, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with leather sofa, coffee table, desk, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d3f7d2f-d16b-4842-a8ce-7cace11ab143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-bd7a-74a7-9f9e-34595eab69dd.webp",
      "image_media": {
        "alt_text": "Open concept living area with kitchen island, living room furniture, and dining area.",
        "public_id": "019e1cd2-bd7a-74a7-9f9e-34595eab69dd",
        "storage_key": "property/6767906449165603/019e1cd2-bd7a-74a7-9f9e-34595eab69dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen island, a comfortable living room with ample seating, and a dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Open concept living area with kitchen island, living room furniture, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5c1e948-19c3-492f-b300-754fd1ce7e22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-bfad-7688-8bee-ecf39f624910.webp",
      "image_media": {
        "alt_text": "Living room with dining table, sofa, TV, and decorative elements.",
        "public_id": "019e1cd2-bfad-7688-8bee-ecf39f624910",
        "storage_key": "property/6767906449165603/019e1cd2-bfad-7688-8bee-ecf39f624910.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious living area featuring a comfortable sofa, a dining table, and a modern entertainment center. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with dining table, sofa, TV, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_824c82ad-a952-4e16-a956-f00f55fc6b33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-bfa3-75fc-860c-db81e1274623.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, chairs, coffee table, and TV.",
        "public_id": "019e1cd2-bfa3-75fc-860c-db81e1274623",
        "storage_key": "property/6767906449165603/019e1cd2-bfa3-75fc-860c-db81e1274623.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring comfortable seating, a large TV, and elegant decor. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Modern living room with a sofa, chairs, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_399b423b-7f26-4fc7-b507-e09492673891",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-bd19-706f-930b-a78b316dda6d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, marble countertops, and a breakfast bar with two velvet stools.",
        "public_id": "019e1cd2-bd19-706f-930b-a78b316dda6d",
        "storage_key": "property/6767906449165603/019e1cd2-bd19-706f-930b-a78b316dda6d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and elegant marble countertops. Enjoy casual meals at the breakfast bar, perfect for morning coffee or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, marble countertops, and a breakfast bar with two velvet stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d0e6deb-672f-488f-b349-82d962da260b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-b794-744f-922b-fbc9753f551c.webp",
      "image_media": {
        "alt_text": "Stylish living and dining area with plush seating, a round dining table, and modern decor.",
        "public_id": "019e1cd2-b794-744f-922b-fbc9753f551c",
        "storage_key": "property/6767906449165603/019e1cd2-b794-744f-922b-fbc9753f551c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable and stylish living in this beautifully appointed apartment, featuring a spacious living area and a dedicated dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Stylish living and dining area with plush seating, a round dining table, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2df3674-69c5-4571-a60e-62d6a40b8a50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd2-bc08-7550-9030-01c2f553bcf9.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with stainless steel appliances, granite countertops, and a butterfly decoration.",
        "public_id": "019e1cd2-bc08-7550-9030-01c2f553bcf9",
        "storage_key": "property/6767906449165603/019e1cd2-bc08-7550-9030-01c2f553bcf9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and elegant countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern gray kitchen with stainless steel appliances, granite countertops, and a butterfly decoration.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_885bf87e-545c-4de5-9d59-4af5a3b2e034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-f454-7110-8322-45f46bd7448e.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019e1cd0-f454-7110-8322-45f46bd7448e",
        "storage_key": "property/6767906449165603/019e1cd0-f454-7110-8322-45f46bd7448e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and a vibrant turquoise side table. Enjoy the resort-style ambiance with modern apartment buildings framing the scene.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d0d743e-2a43-4d6c-9691-04d0ca0e6c01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-fe7e-727a-89f8-58be7ec972d3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana",
        "public_id": "019e1cd0-fe7e-727a-89f8-58be7ec972d3",
        "storage_key": "property/6767906449165603/019e1cd0-fe7e-727a-89f8-58be7ec972d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, featuring comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45da33f8-36ba-4fbd-b561-16e3f162d939",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-ec39-74ca-b3e6-24c7163f48ab.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a cabana area.",
        "public_id": "019e1cd0-ec39-74ca-b3e6-24c7163f48ab",
        "storage_key": "property/6767906449165603/019e1cd0-ec39-74ca-b3e6-24c7163f48ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a cabana area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c68a658f-ffb6-4056-9fd4-8ffbdf5409c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-eed6-7031-92d6-15234a1895ec.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs under a large umbrella.",
        "public_id": "019e1cd0-eed6-7031-92d6-15234a1895ec",
        "storage_key": "property/6767906449165603/019e1cd0-eed6-7031-92d6-15234a1895ec.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Relax and unwind by our resort-style swimming pool, featuring comfortable lounge chairs and tanning ledges perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs under a large umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b679c94-43bf-48d5-b7bc-d23218a8ba86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-f969-71a9-8f93-cf6397c73ce4.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with teal seating, coffee tables, and a mounted TV, adjacent to a grilling station.",
        "public_id": "019e1cd0-f969-71a9-8f93-cf6397c73ce4",
        "storage_key": "property/6767906449165603/019e1cd0-f969-71a9-8f93-cf6397c73ce4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish outdoor lounge, complete with comfortable seating, a large TV, and a convenient grilling station for al fresco dining.",
      "link": "",
      "alt_text": "Outdoor lounge area with teal seating, coffee tables, and a mounted TV, adjacent to a grilling station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8692094-2190-4cda-926c-351f2b5d3499",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-fe4d-7739-a26a-44407d30c372.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in grills and stone counter tops.",
        "public_id": "019e1cd0-fe4d-7739-a26a-44407d30c372",
        "storage_key": "property/6767906449165603/019e1cd0-fe4d-7739-a26a-44407d30c372.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's built-in grilling stations, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in grills and stone counter tops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94c47b3c-06bd-4d54-bb17-77ba90c5fa20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-ce4b-7149-a17a-344a95dbffd5.webp",
      "image_media": {
        "alt_text": "Mail center and apartment buildings with green lawn.",
        "public_id": "019e1cd0-ce4b-7149-a17a-344a95dbffd5",
        "storage_key": "property/6767906449165603/019e1cd0-ce4b-7149-a17a-344a95dbffd5.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Exterior view of the mail center and apartment buildings. Enjoy convenient access to package and mail services right on the property.",
      "link": "",
      "alt_text": "Mail center and apartment buildings with green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0101433-4470-4008-9bb4-15c4f7770d7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-8185-7297-b7b3-d627833c4dbe.webp",
      "image_media": {
        "alt_text": "Crossing Cypress Luxury Apartments monument sign",
        "public_id": "019e1cd0-8185-7297-b7b3-d627833c4dbe",
        "storage_key": "property/6767906449165603/019e1cd0-8185-7297-b7b3-d627833c4dbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Crossing Cypress Luxury Apartments, featuring a prominent monument sign at the entrance.",
      "link": "",
      "alt_text": "Crossing Cypress Luxury Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d967bf22-430a-4f4a-8f99-be95cd13f4c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-e160-748d-a939-508924e28d2f.webp",
      "image_media": {
        "alt_text": "View of the apartment complex pool area with lounge chairs and a modern sculpture.",
        "public_id": "019e1cd0-e160-748d-a939-508924e28d2f",
        "storage_key": "property/6767906449165603/019e1cd0-e160-748d-a939-508924e28d2f.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our resort-style pool, complete with comfortable lounge seating and a unique outdoor sculpture.",
      "link": "",
      "alt_text": "View of the apartment complex pool area with lounge chairs and a modern sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba36112f-6b22-4c16-bda0-3a35f3bd8716",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-d87d-731a-b92c-8735bc4ba4e0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and surrounding apartment buildings.",
        "public_id": "019e1cd0-d87d-731a-b92c-8735bc4ba4e0",
        "storage_key": "property/6767906449165603/019e1cd0-d87d-731a-b92c-8735bc4ba4e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and ample space for sunbathing.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6bdfa68e-d962-45ae-80c4-84b59458c3aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-af7e-720b-bfbc-beb37f213064.webp",
      "image_media": {
        "alt_text": "View from apartment balcony of the surrounding community including buildings, parking, and landscaping.",
        "public_id": "019e1cd0-af7e-720b-bfbc-beb37f213064",
        "storage_key": "property/6767906449165603/019e1cd0-af7e-720b-bfbc-beb37f213064.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the scenic views from your private apartment balcony, overlooking the community's amenities and landscaping.",
      "link": "",
      "alt_text": "View from apartment balcony of the surrounding community including buildings, parking, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_146bba13-8d5d-48cb-b206-cf6e9ba6c415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-ca96-72ed-85b5-26c4c33e80e6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walkway and courtyard.",
        "public_id": "019e1cd0-ca96-72ed-85b5-26c4c33e80e6",
        "storage_key": "property/6767906449165603/019e1cd0-ca96-72ed-85b5-26c4c33e80e6.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Beautifully landscaped courtyard with a paved walkway leading to modern apartment buildings. Enjoy the community's exterior and common areas.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a walkway and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0cc0922-dd27-4eb4-a77c-7a2a75fcf3c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-ac21-771e-9dfb-c8f6ae5f4630.webp",
      "image_media": {
        "alt_text": "View from a balcony of a modern apartment complex with a pool and clubhouse.",
        "public_id": "019e1cd0-ac21-771e-9dfb-c8f6ae5f4630",
        "storage_key": "property/6767906449165603/019e1cd0-ac21-771e-9dfb-c8f6ae5f4630.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the amenities of our apartment community, including a sparkling pool and a stylish clubhouse.",
      "link": "",
      "alt_text": "View from a balcony of a modern apartment complex with a pool and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c95fe289-40cd-4e82-a1b1-c2340e68ca8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-68d7-709d-a786-d2050e359290.webp",
      "image_media": {
        "alt_text": "Cypress Crossing apartment building exterior with parking lot and handicap spaces in the foreground.",
        "public_id": "019e1cd0-68d7-709d-a786-d2050e359290",
        "storage_key": "property/6767906449165603/019e1cd0-68d7-709d-a786-d2050e359290.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome home to Cypress Crossing, featuring modern apartment living with convenient amenities and accessible parking.",
      "link": "",
      "alt_text": "Cypress Crossing apartment building exterior with parking lot and handicap spaces in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2268099b-4bac-46f5-990f-d0f03efd2169",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-671a-70db-9608-d606662070ca.webp",
      "image_media": {
        "alt_text": "Cypress Crossing apartment building exterior with welcome banner and reserved parking sign.",
        "public_id": "019e1cd0-671a-70db-9608-d606662070ca",
        "storage_key": "property/6767906449165603/019e1cd0-671a-70db-9608-d606662070ca.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Welcome to Cypress Crossing, an apartment community featuring modern architecture and convenient reserved parking.",
      "link": "",
      "alt_text": "Cypress Crossing apartment building exterior with welcome banner and reserved parking sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e8f7e35-2776-45d1-8088-b6b4859b2d74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-9329-720b-baf5-8ea092e4a32f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with fountains and lounge chairs, with apartment buildings in the background.",
        "public_id": "019e1cd0-9329-720b-baf5-8ea092e4a32f",
        "storage_key": "property/6767906449165603/019e1cd0-9329-720b-baf5-8ea092e4a32f.webp",
        "width": 3072,
        "height": 2029
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, complete with fountains and comfortable lounge seating. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with fountains and lounge chairs, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98d33190-65d4-43c2-b0c3-95f9c9194718",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-6945-72e0-89fc-b86c7f206726.webp",
      "image_media": {
        "alt_text": "Modern building exterior with a grand entrance and landscaped grounds.",
        "public_id": "019e1cd0-6945-72e0-89fc-b86c7f206726",
        "storage_key": "property/6767906449165603/019e1cd0-6945-72e0-89fc-b86c7f206726.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community's stunning clubhouse, featuring a modern architectural design and beautiful landscaping.",
      "link": "",
      "alt_text": "Modern building exterior with a grand entrance and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10b83123-1721-4d97-909c-b6f1ffb1a93e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-67ca-77ca-bfa7-fd27702c7e5e.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and pool in the background",
        "public_id": "019e1cd0-67ca-77ca-bfa7-fd27702c7e5e",
        "storage_key": "property/6767906449165603/019e1cd0-67ca-77ca-bfa7-fd27702c7e5e.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax and unwind in our community's outdoor seating area featuring a fire pit and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and pool in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e73f7a05-a616-4ba0-b6c7-90c6b56cfe62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-6612-720c-925f-0fd11e7d870d.webp",
      "image_media": {
        "alt_text": "View of the community pool and apartment buildings.",
        "public_id": "019e1cd0-6612-720c-925f-0fd11e7d870d",
        "storage_key": "property/6767906449165603/019e1cd0-6612-720c-925f-0fd11e7d870d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax by the sparkling community pool, surrounded by lush landscaping and modern apartment buildings. Enjoy the perfect getaway at home.",
      "link": "",
      "alt_text": "View of the community pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d48699c9-cbf1-450c-bc76-638612185c3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-6627-7567-83bc-59e43578ae74.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
        "public_id": "019e1cd0-6627-7567-83bc-59e43578ae74",
        "storage_key": "property/6767906449165603/019e1cd0-6627-7567-83bc-59e43578ae74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring attached garages and ample parking, set against a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67e1a50d-ef2d-452c-821d-2cb5b433b614",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-bda7-706d-99e3-ba28f47901e0.webp",
      "image_media": {
        "alt_text": "Lobby area with sofas, chairs, fireplace, and reception desk.",
        "public_id": "019e1cce-bda7-706d-99e3-ba28f47901e0",
        "storage_key": "property/6767906449165603/019e1cce-bda7-706d-99e3-ba28f47901e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stylish and inviting lobby with comfortable seating, a modern fireplace, and a prominent reception desk with a branded backdrop.",
      "link": "",
      "alt_text": "Lobby area with sofas, chairs, fireplace, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72fb19f7-a689-4d9e-89f8-5b351acc2a37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-c223-75df-964b-400a464ea345.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio equipment and weight machines",
        "public_id": "019e1cce-c223-75df-964b-400a464ea345",
        "storage_key": "property/6767906449165603/019e1cce-c223-75df-964b-400a464ea345.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio machines and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with cardio equipment and weight machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5fb1660c-09f0-41d5-8f03-f4924495e84a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-c0aa-7408-a9e5-53e584637662.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, free weights, and weightlifting equipment.",
        "public_id": "019e1cce-c0aa-7408-a9e5-53e584637662",
        "storage_key": "property/6767906449165603/019e1cce-c0aa-7408-a9e5-53e584637662.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio machines, free weights, and weightlifting equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de183548-2cf2-4e33-a083-81cf218d54eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-ba0a-726e-8ea1-c7557fb9fca5.webp",
      "image_media": {
        "alt_text": "A spacious apartment community lounge area with a modern kitchen island, seating, and a fireplace.",
        "public_id": "019e1cce-ba0a-726e-8ea1-c7557fb9fca5",
        "storage_key": "property/6767906449165603/019e1cce-ba0a-726e-8ea1-c7557fb9fca5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring a state-of-the-art kitchen, comfortable seating areas, and a cozy fireplace.",
      "link": "",
      "alt_text": "A spacious apartment community lounge area with a modern kitchen island, seating, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8321f32a-c957-4bf8-89c8-f8c205bda4e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-734d-77fc-ac23-f2abbbff7b35.webp",
      "image_media": {
        "alt_text": "Cypress Crossing amenity center with pool table, TVs, and lounge area.",
        "public_id": "019e1cce-734d-77fc-ac23-f2abbbff7b35",
        "storage_key": "property/6767906449165603/019e1cce-734d-77fc-ac23-f2abbbff7b35.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy your downtime in the Cypress Crossing amenity center, featuring a billiards table, lounge seating, and entertainment TVs.",
      "link": "",
      "alt_text": "Cypress Crossing amenity center with pool table, TVs, and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_648afff8-d55a-4472-8f9e-6385a25031fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-7405-7742-bf18-f941b3a14b9c.webp",
      "image_media": {
        "alt_text": "Stylish living room with modern fireplace and large windows",
        "public_id": "019e1cce-7405-7742-bf18-f941b3a14b9c",
        "storage_key": "property/6767906449165603/019e1cce-7405-7742-bf18-f941b3a14b9c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our spacious and beautifully designed common living area, featuring a contemporary fireplace and ample natural light.",
      "link": "",
      "alt_text": "Stylish living room with modern fireplace and large windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d909ed7-0109-445e-99b3-95a89f9be465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-8b18-75b0-85a5-ae30ace8dcef.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception area with a large teal accent wall featuring the property name 'Cypress Crossing Luxury Apartments'.",
        "public_id": "019e1cce-8b18-75b0-85a5-ae30ace8dcef",
        "storage_key": "property/6767906449165603/019e1cce-8b18-75b0-85a5-ae30ace8dcef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the leasing office of Cypress Crossing Luxury Apartments. Experience our modern design and inviting atmosphere.",
      "link": "",
      "alt_text": "Modern leasing office reception area with a large teal accent wall featuring the property name 'Cypress Crossing Luxury Apartments'.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_339c5117-3922-4758-8980-33dcda0af265",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-72d4-7411-a41c-5706a48dc270.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace and seating area",
        "public_id": "019e1cce-72d4-7411-a41c-5706a48dc270",
        "storage_key": "property/6767906449165603/019e1cce-72d4-7411-a41c-5706a48dc270.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stylish lobby with a modern fireplace, comfortable seating, and decorative elements. Enjoy this welcoming space at our property.",
      "link": "",
      "alt_text": "Lobby with fireplace and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fe26aa3-f22e-4d26-9475-43439674ab94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-8b20-737f-ba16-b08c73595311.webp",
      "image_media": {
        "alt_text": "Modern gym with weights, machines, and a workout bench.",
        "public_id": "019e1cce-8b20-737f-ba16-b08c73595311",
        "storage_key": "property/6767906449165603/019e1cce-8b20-737f-ba16-b08c73595311.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Modern gym with weights, machines, and a workout bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_277e79d6-6d58-4392-9d4c-6b7baf12636f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cce-739c-723d-a00f-f2b9a50deebf.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight machines, and free weights, overlooking the pool area.",
        "public_id": "019e1cce-739c-723d-a00f-f2b9a50deebf",
        "storage_key": "property/6767906449165603/019e1cce-739c-723d-a00f-f2b9a50deebf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including cardio machines, strength training equipment, and free weights. Enjoy your workout with views of the resort-style pool.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight machines, and free weights, overlooking the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8a2cf50-e1db-4947-a167-f93b2907f81f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e2196-b76e-7689-ad52-3bc8a74eb616.webp",
      "image_media": {
        "alt_text": "Cypress Crossing community room with pool table and lounge seating.",
        "public_id": "019e2196-b76e-7689-ad52-3bc8a74eb616",
        "storage_key": "property/6767906449165603/019e2196-b76e-7689-ad52-3bc8a74eb616.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy games and relaxation in the Cypress Crossing community room, featuring a pool table and comfortable seating.",
      "link": "",
      "alt_text": "Cypress Crossing community room with pool table and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_60ef5694-3030-4807-aebc-8ccc6c4a0475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "9311 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Family-friendly chain serving steaks (hand-cut, and prime or ribeye), ribs and bread rolls with cinnamon butter.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and appetizers. They also highlight the quick service, friendly staff, and attentive management.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f2a8-7539-be32-9a9fcc51c03d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f2a8-7539-be32-9a9fcc51c03d",
        "storage_key": "property/6767906449165603/019cfb3f-f2a8-7539-be32-9a9fcc51c03d.webp",
        "width": 560,
        "height": 315
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/owasso?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7489778363057715607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.2890186",
      "poi_longitude": "-95.8379704",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-516-1075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cw0P4XxtocRlzl2GL0J8Wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_e65fc992-b566-430b-9e5b-c1ff2918ee4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "MAD Eats",
      "poi_type": "Restaurants",
      "poi_address": "201 S Main St STE #130, Owasso, OK 74055, USA",
      "poi_short_description": "Casual eatery serving burgers, tacos, mac and cheese, sandwiches, breakfast items, meatloaf and shakes.",
      "poi_long_description": "People say this diner serves delicious burgers, fries, and shakes. They also highlight the fun atmosphere, generous portions, and friendly service.\n\nOther reviews mention the food quality can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f345-73e9-9bd7-e623c2ee4a69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f345-73e9-9bd7-e623c2ee4a69",
        "storage_key": "property/6767906449165603/019cfb3f-f345-73e9-9bd7-e623c2ee4a69.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.madeatsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1802710814106412544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mad-eats",
      "poi_latitude": "36.2635117",
      "poi_longitude": "-95.8542858",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-401-4353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZLFS_bwtocRAGaRK--DBBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_29c6adc4-cca1-449b-894c-700a78a34bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "13301 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Chain fast-food eatery serving chicken fingers and sandwiches, plus Texas toast and fries.Friendly staff.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, crinkle-cut fries, and Texas toast. They also highlight the friendly and efficient service, and the restaurant's affordable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f367-71dd-8050-5727152aa141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f367-71dd-8050-5727152aa141",
        "storage_key": "property/6767906449165603/019cfb3f-f367-71dd-8050-5727152aa141.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/owasso/13301-e.-96th-st.-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=11347752542593289881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.2934128",
      "poi_longitude": "-95.826651",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-376-9426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwe5cajwtocRmQ5PhNBQe50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1fa3354f-8ca8-4c16-a763-f0ca3495d895",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Restaurants",
      "poi_address": "11590 N 140th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Gas station equipped for quick bites and pizza, also featuring soft-serve ice cream and a fountain.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f2c8-7748-bbdf-7e4e224a3f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f2c8-7748-bbdf-7e4e224a3f60",
        "storage_key": "property/6767906449165603/019cfb3f-f2c8-7748-bbdf-7e4e224a3f60.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ok/owasso/11590-n-140th-e-ave?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075741749885667753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "36.32114",
      "poi_longitude": "-95.8192628",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-371-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZXXJSH6tocRqQn-B2zN7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ddd5ad87-e2a8-45f8-8d91-a6137b512f38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12015 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Fast food chain for chicken sandwiches and nuggets, plus waffle fries, salads, and breakfast.",
      "poi_long_description": "Diners say this chicken restaurant has friendly and polite staff who always greet customers with a smile. They also highlight the delicious and fresh food, especially the hot and tasty chicken.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f308-72ea-9526-5a038c1f78c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f308-72ea-9526-5a038c1f78c8",
        "storage_key": "property/6767906449165603/019cfb3f-f308-72ea-9526-5a038c1f78c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/owasso-market?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068432268636994183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.29352799999999",
      "poi_longitude": "-95.8402253",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-7201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTsZDJ7wtocRhzp0HeRClSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0c2a8f2e-b2b5-4d7a-bef0-4ff40172cbee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9450 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retailer for home equipment and building materials, plus tools, appliances and other goods.",
      "poi_long_description": "People say this home improvement store has helpful staff and a good selection of equipment rentals. They also highlight the friendly and knowledgeable staff, and the clean and tidy store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f309-729f-b0de-a31b99980484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f309-729f-b0de-a31b99980484",
        "storage_key": "property/6767906449165603/019cfb3f-f309-729f-b0de-a31b99980484.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Owasso/OK/Owasso/74055/8922?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344320956374293089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.2902973",
      "poi_longitude": "-95.8317215",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-376-9975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP-C7bKHwtocRYZrNjMn8pxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f59f7c73-a744-4a02-9dce-e7703cfb0340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "12001 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Home-improvement chain for tools, appliances, patio furniture, lumber, and paint that also sells plants.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home repair projects. They also highlight the helpful and friendly staff, and the clean and organized facility.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f30b-7334-8b37-10194ecdece6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f30b-7334-8b37-10194ecdece6",
        "storage_key": "property/6767906449165603/019cfb3f-f30b-7334-8b37-10194ecdece6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Owasso/1500?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1500-_-na-_-0-_-0&y_source=1_MTE4NDM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10101766130383154022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.295125",
      "poi_longitude": "-95.841189",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-0881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJWmL4Z_wtocRZmuPLcauMIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_46d6c875-c96d-45f6-a6e7-6d8add58bd91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9601 N 133rd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Farmers market stocking organic food and produce plus meat and seafood counters.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic products, and less common meats, as well as sushi and sprouts. They highlight the great prices and the clean, well-stocked store. They also like the friendly, knowledgeable, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f3eb-7378-b6ab-d4dacde862cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f3eb-7378-b6ab-d4dacde862cc",
        "storage_key": "property/6767906449165603/019cfb3f-f3eb-7378-b6ab-d4dacde862cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/owasso/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=6349055451709502037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.294403",
      "poi_longitude": "-95.8260493",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-516-6656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0673-71ed-b24f-2f58b15f158a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0673-71ed-b24f-2f58b15f158a",
        "storage_key": "property/6767906449165603/019cfb40-0673-71ed-b24f-2f58b15f158a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbryiqfwtocRVfJmaktgHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ce3bf53a-e7b8-453a-b8de-3892f5db3488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "9046 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Discount chain selling brand-name clothing for men, women and kids, as well as shoes and perfumes.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f367-71dd-8050-5b97f3be84e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f367-71dd-8050-5b97f3be84e9",
        "storage_key": "property/6767906449165603/019cfb3f-f367-71dd-8050-5b97f3be84e9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7226706442748966127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "36.291631",
      "poi_longitude": "-95.8415924",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-3699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOkQZzwtocR7zQUkDhrSmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_5284c7fe-730b-4e5d-8617-0f4a5077063f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11815 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Supermarket, bakery, and pharmacy chain offering a variety of goods including meat and produce.",
      "poi_long_description": "People say this grocery store offers a variety of groceries and snacks. They also highlight the helpful and caring service.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f39c-73ab-aa1a-abe4759703af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f39c-73ab-aa1a-abe4759703af",
        "storage_key": "property/6767906449165603/019cfb3f-f39c-73ab-aa1a-abe4759703af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.reasors.com/stores/owasso-south-86th",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836905338792957670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reasors",
      "poi_latitude": "36.2798262",
      "poi_longitude": "-95.8425677",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-272-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0673-71ed-b24f-2f58b15f158a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0673-71ed-b24f-2f58b15f158a",
        "storage_key": "property/6767906449165603/019cfb40-0673-71ed-b24f-2f58b15f158a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3xRcJHwtocR5tbll0m1g4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_25ff454b-181f-4ffb-8cb7-28ae40754d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Library",
      "poi_type": "Education",
      "poi_address": "314 E 5th Ave Suite 202, Owasso, OK 74055, USA",
      "poi_short_description": "Community resource offering books and movies, plus educational programs and events.",
      "poi_long_description": "People say this public library has a wide selection of books, including vegetarian cookbooks, and offers a food drive that benefits the community. They also highlight the helpful and friendly staff who greet visitors and offer assistance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f68b-75df-8ac0-062e9c287455.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f68b-75df-8ac0-062e9c287455",
        "storage_key": "property/6767906449165603/019cfb3f-f68b-75df-8ac0-062e9c287455.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/owasso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8627652818677722310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-library",
      "poi_latitude": "36.2581947",
      "poi_longitude": "-95.8497147",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnaj5dPbwtocRxuyu_oaUu3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_99fa608a-9454-4868-930d-d9e8c4962ee9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Airtopia Adventure Park - Owasso",
      "poi_type": "Entertainment",
      "poi_address": "12932 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Multi-dimensional indoor amusement center offers trampolines, a warrior course, and more.",
      "poi_long_description": "People say this theme park offers a variety of fun activities, including trampolines, obstacle courses, and an arcade, and is a great place for birthday parties. They also highlight the clean facility, friendly and helpful staff, and the fun atmosphere for kids of all ages.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f6db-71be-bce7-f47ca1b5dcdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f6db-71be-bce7-f47ca1b5dcdf",
        "storage_key": "property/6767906449165603/019cfb3f-f6db-71be-bce7-f47ca1b5dcdf.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.airtopiapark.com/owasso?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729509317578422024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airtopia-adventure-park---owasso",
      "poi_latitude": "36.2766921",
      "poi_longitude": "-95.8278842",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-201-1612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-TfgZDxtocRCHfF7PbgwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_0a2ae385-d897-4cdc-996e-0d95aa183772",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Stadium",
      "poi_type": "Entertainment",
      "poi_address": "12901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f6db-71be-bce7-f2064159fa0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f6db-71be-bce7-f2064159fa0e",
        "storage_key": "property/6767906449165603/019cfb3f-f6db-71be-bce7-f2064159fa0e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2455",
      "poi_directions_map_url": "https://maps.google.com/?cid=14776732685769457826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-stadium",
      "poi_latitude": "36.2814643",
      "poi_longitude": "-95.8285307",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-101aa6c57d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-101aa6c57d7d",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-101aa6c57d7d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5n_8kDxtocRokAxVBaAEc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0b9830f1-4823-4eb9-a336-3eefb0a600cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Roundup",
      "poi_type": "Entertainment",
      "poi_address": "8120 N 91st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f6d1-74ae-b21a-1517eba985ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f6d1-74ae-b21a-1517eba985ff",
        "storage_key": "property/6767906449165603/019cfb3f-f6d1-74ae-b21a-1517eba985ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10984323416409265704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-roundup",
      "poi_latitude": "36.2728275",
      "poi_longitude": "-95.8742976",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-694-4513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnz_3TFHxtocRKFYUJfMncJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_80583e45-fd0c-4e38-9266-6a4a6730b93a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Museum",
      "poi_type": "Entertainment",
      "poi_address": "26 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f770-70e4-a77c-1dd019c24208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f770-70e4-a77c-1dd019c24208",
        "storage_key": "property/6767906449165603/019cfb3f-f770-70e4-a77c-1dd019c24208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/283/Historical-Museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=6857264842603068093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-museum",
      "poi_latitude": "36.2654952",
      "poi_longitude": "-95.8552377",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-272-4966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-066a-725d-afdf-0f967dda0f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-066a-725d-afdf-0f967dda0f6b",
        "storage_key": "property/6767906449165603/019cfb40-066a-725d-afdf-0f967dda0f6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQwKbfbwtocRvXohAgvmKV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_450d61a7-c238-4e01-8928-22578f641787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Collinsville Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901-1999 W Maple St, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f78a-75fe-abc0-15bfb214c496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f78a-75fe-abc0-15bfb214c496",
        "storage_key": "property/6767906449165603/019cfb3f-f78a-75fe-abc0-15bfb214c496.webp",
        "width": 1280,
        "height": 784
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2529",
      "poi_directions_map_url": "https://maps.google.com/?cid=12965247704748893086&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "collinsville-stadium",
      "poi_latitude": "36.367661",
      "poi_longitude": "-95.8486856",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-101aa6c57d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-101aa6c57d7d",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-101aa6c57d7d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBdGdJ5v7tocRnqOBOhjQ7bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_03564f51-ed89-427d-99a3-edefb6ccf9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "507 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Gym with the latest cardio and strength-training equipment, as well as classes and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines and free weights, and has amenities such as a sauna and aqua massage chairs. They highlight the affordable membership, 24/7 access, and clean facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f747-722a-ab81-3eb5a53743a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f747-722a-ab81-3eb5a53743a2",
        "storage_key": "property/6767906449165603/019cfb3f-f747-722a-ab81-3eb5a53743a2.webp",
        "width": 825,
        "height": 462
      },
      "poi_business_url": "https://10gym.com/owasso-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8859217771743011312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.2651727",
      "poi_longitude": "-95.8500497",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-609-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG85Rt3n3tocR8OGREKBD8no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_252abf7e-9d9c-4379-9ba3-3ff6d6f89572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Barber Sports Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "11622 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Popular barbershop specializing in straight-razor shaves and detailed haircuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f796-701d-a8b2-407f4fd2182c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f796-701d-a8b2-407f4fd2182c",
        "storage_key": "property/6767906449165603/019cfb3f-f796-701d-a8b2-407f4fd2182c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://placegem.top/barber-sports-lounge-cnilcpw",
      "poi_directions_map_url": "https://maps.google.com/?cid=11273226578980552883&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barber-sports-lounge",
      "poi_latitude": "36.277631",
      "poi_longitude": "-95.8451781",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-609-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQYHk5HwtocRs8CgcNiLcpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_6fb0d02e-ca12-4b76-8912-5dca335f7eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "SAHO Owasso Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12555 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f7ee-77d0-9269-a21bd1ff73de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f7ee-77d0-9269-a21bd1ff73de",
        "storage_key": "property/6767906449165603/019cfb3f-f7ee-77d0-9269-a21bd1ff73de.webp",
        "width": 1128,
        "height": 636
      },
      "poi_business_url": "https://sahovets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7283601458760437127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saho-owasso-animal-hospital",
      "poi_latitude": "36.2797463",
      "poi_longitude": "-95.8339312",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZu1473wtocRh83uwu-MFGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b2363a45-e1d4-4e4d-987b-eff863fc3ad5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "9018 N 121st E Ave #500, Owasso, OK 74055, USA",
      "poi_short_description": "Well-stocked retailer of makeup, fragrances and beauty supplies, with salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-f7f8-73b9-bd1a-a28a5f98afd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-f7f8-73b9-bd1a-a28a5f98afd6",
        "storage_key": "property/6767906449165603/019cfb3f-f7f8-73b9-bd1a-a28a5f98afd6.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/owasso-ok-1438",
      "poi_directions_map_url": "https://maps.google.com/?cid=1286153677870263124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.2904072",
      "poi_longitude": "-95.8434629",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-973-6449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJff9n0OPxtocRVOsEqPRV2RE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9107576a-2753-4e47-8dc9-b67284466b4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "9045 N 121st E Ave Suite 1200, Owasso, OK 74055, USA",
      "poi_short_description": "Casual shop for men's and boys' haircuts as well as beard trimming and shaping. Also offers MVP treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fab7-75df-b61c-e18070e41b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fab7-75df-b61c-e18070e41b4d",
        "storage_key": "property/6767906449165603/019cfb3f-fab7-75df-b61c-e18070e41b4d.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ok-owasso-ok103?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715315186473060055&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-owasso",
      "poi_latitude": "36.2901849",
      "poi_longitude": "-95.8404563",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4_3H5zwtocR10Y_yH6WVr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_a4ff77f2-cc36-4e93-924e-de2808004c1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 N 129th E Ave Ste 124, Owasso, OK 74055, USA",
      "poi_short_description": "Chain salon and barber shop offering trims for kids and adults in an affordable setting with walk-ins welcome.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-faba-76dc-9bce-8d672b0911f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-faba-76dc-9bce-8d672b0911f0",
        "storage_key": "property/6767906449165603/019cfb3f-faba-76dc-9bce-8d672b0911f0.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/ok/owasso/9500-n-129th-e-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1714296183721100132&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "36.2912538",
      "poi_longitude": "-95.8310068",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-274-4561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ4Yy6DwtocRZAOB3ktnyhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_077c52ba-014f-4770-9f9a-816ded160733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Floyd's 99 Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "11340 E 96th St N Ste 400, Owasso, OK 74055, USA",
      "poi_short_description": "Chain barber shop offering haircuts, shaves, and shoulder massages, plus grooming products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fb5c-7519-b8ae-e8c605f25831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fb5c-7519-b8ae-e8c605f25831",
        "storage_key": "property/6767906449165603/019cfb3f-fb5c-7519-b8ae-e8c605f25831.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.floydsbarbershop.com/locations/oklahoma/tulsa/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890106331849848605&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "floyds-99-barbershop",
      "poi_latitude": "36.292556",
      "poi_longitude": "-95.8460274",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-973-4610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8ASMSbxtocRHXdQqh2Sw8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_aaaaee75-2aaa-4ee8-afa1-207c3bdbd801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Airbenders",
      "poi_type": "Health and Wellness",
      "poi_address": "12202 East 93rd St N, Owasso, OK 74055, USA",
      "poi_short_description": "Well-maintained facility offering classes, birthday parties and special events such as Parents Night Out.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fb1d-778a-9d43-fe3c1df8fd13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fb1d-778a-9d43-fe3c1df8fd13",
        "storage_key": "property/6767906449165603/019cfb3f-fb1d-778a-9d43-fe3c1df8fd13.webp",
        "width": 960,
        "height": 588
      },
      "poi_business_url": "http://airbendersgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11097384753689398637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbenders",
      "poi_latitude": "36.2878794",
      "poi_longitude": "-95.8380897",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-928-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeSEalLxtocRbQ1-E6PUAZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2d9b03c0-37e0-4bb6-a2c9-2e2539637a3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "LUSH Nails & Spa OWASSO",
      "poi_type": "Health and Wellness",
      "poi_address": "11560 N 135th E Ave Unit 105, Owasso, OK 74055, USA",
      "poi_short_description": "Clean salon for manicures and pedicures, plus acrylic options and waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fc1d-728b-8617-ed11bb3a26cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fc1d-728b-8617-ed11bb3a26cc",
        "storage_key": "property/6767906449165603/019cfb3f-fc1d-728b-8617-ed11bb3a26cc.webp",
        "width": 608,
        "height": 341
      },
      "poi_business_url": "https://lushnailsandspaowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3743164198816847017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lush-nails--spa-owasso",
      "poi_latitude": "36.3204521",
      "poi_longitude": "-95.825409",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-371-3952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_-V94X7tocRqRRwtgFk8jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_31b3e099-a5d6-494a-a08e-99b07bfb763d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Vintage Barbershop Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "421 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed salon offering an array of services including haircuts, hot towel shaves and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fc6f-75ac-a0cf-e7595bb02f33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fc6f-75ac-a0cf-e7595bb02f33",
        "storage_key": "property/6767906449165603/019cfb3f-fc6f-75ac-a0cf-e7595bb02f33.webp",
        "width": 1206,
        "height": 1191
      },
      "poi_business_url": "http://www.vintagebarbershopcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8470976327735755158&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vintage-barbershop-co",
      "poi_latitude": "36.2648651",
      "poi_longitude": "-95.8520044",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-998-6919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcc8BAvxtocRlsFuwxb0jnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_281f3f8b-c513-49d9-ae8d-9daf9d9096c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Bailey Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10502 N 110th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fc6f-75ac-a0cf-e1180394dc56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fc6f-75ac-a0cf-e1180394dc56",
        "storage_key": "property/6767906449165603/019cfb3f-fc6f-75ac-a0cf-e1180394dc56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://baileymedicalcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4717141264462008518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bailey-medical-center",
      "poi_latitude": "36.3050528",
      "poi_longitude": "-95.8530191",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0766-7786-9d3c-c84c2b0bf1a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0766-7786-9d3c-c84c2b0bf1a7",
        "storage_key": "property/6767906449165603/019cfb40-0766-7786-9d3c-c84c2b0bf1a7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0XFJmP6tocRxlCYz_ymdkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e832c44f-ad6d-488d-80f9-ff46f4c95416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Ascension St. John Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "12451 E 100th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fc72-7785-95f5-93f2be57caab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fc72-7785-95f5-93f2be57caab",
        "storage_key": "property/6767906449165603/019cfb3f-fc72-7785-95f5-93f2be57caab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/owasso-ascension-st-john-owasso?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4519634255069400250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-st-john-owasso",
      "poi_latitude": "36.2992565",
      "poi_longitude": "-95.8353676",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-274-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0766-7786-9d3c-c84c2b0bf1a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0766-7786-9d3c-c84c2b0bf1a7",
        "storage_key": "property/6767906449165603/019cfb40-0766-7786-9d3c-c84c2b0bf1a7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtX2-TAv6tocRukwZsGj3uD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bcd711cf-ab17-4f74-a9a1-01970142ee61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "The Patriot Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5790 N Patriot Dr, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed, welcoming golf club boasting scenic views and featuring an eatery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fdae-747e-b2f6-acb9f92fd8ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fdae-747e-b2f6-acb9f92fd8ec",
        "storage_key": "property/6767906449165603/019cfb3f-fdae-747e-b2f6-acb9f92fd8ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.patriotgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13926276483344965530&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-patriot-golf-club",
      "poi_latitude": "36.2386179",
      "poi_longitude": "-95.7725533",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-272-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-067b-71a7-b480-c90ae84648a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-067b-71a7-b480-c90ae84648a8",
        "storage_key": "property/6767906449165603/019cfb40-067b-71a7-b480-c90ae84648a8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2fvcfH2tocRmh-nUa0SRME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_749ffcf3-b053-4293-b24a-c9f962196742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Bailey Ranch Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10105 Larkin Bailey Blvd, Owasso, OK 74055, USA",
      "poi_short_description": "Public golf venue featuring greens and fairways along with a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-fe05-7073-aad9-e371c1c89201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-fe05-7073-aad9-e371c1c89201",
        "storage_key": "property/6767906449165603/019cfb3f-fe05-7073-aad9-e371c1c89201.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baileyranchgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16134891853489105549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bailey-ranch-golf-course",
      "poi_latitude": "36.2837033",
      "poi_longitude": "-95.8633842",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-274-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-067b-71a7-b480-c90ae84648a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-067b-71a7-b480-c90ae84648a8",
        "storage_key": "property/6767906449165603/019cfb40-067b-71a7-b480-c90ae84648a8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJycM7dnzwtocRjeqPiKem6t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1417a664-adb9-402a-ae0c-495a12140efc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Funtastic Island",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10320 E 116th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Park featuring both a playground and a splash area equipped with a bucket feature.",
      "poi_long_description": "People say this park offers a fun playground, splash pad, and a giant water bucket. They highlight the clean, modern, and safe environment, and the easy access to parking and restrooms. They also like the smooth walkways and the availability of shade. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-ff30-769d-a443-5b2b3a3f2a26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-ff30-769d-a443-5b2b3a3f2a26",
        "storage_key": "property/6767906449165603/019cfb3f-ff30-769d-a443-5b2b3a3f2a26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/Facilities/Facility/Details/Funtastic-Island-6",
      "poi_directions_map_url": "https://maps.google.com/?cid=618726252255915832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "funtastic-island",
      "poi_latitude": "36.3212018",
      "poi_longitude": "-95.859361",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-376-1529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-067a-7495-a9e3-8622cedbf612",
        "storage_key": "property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZTf9_b6tocROC_sjj8olgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_47553a33-f10e-4d44-b6f2-1b5094537055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15301 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Family-friendly destination boasting a playground, disc golf and ponds.",
      "poi_long_description": "People say this park offers an eighteen-hole disc golf course, walking trails, covered picnic tables, and bathrooms. They highlight the diverse and scenic course with a variety of shots, and the abundance of wildlife. They also like the friendly people and fishing spots. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-ff8d-731b-b33e-01651f683df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-ff8d-731b-b33e-01651f683df5",
        "storage_key": "property/6767906449165603/019cfb3f-ff8d-731b-b33e-01651f683df5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.cityofowasso.com/152/Recreation-and-Culture",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374206344880589576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "36.2788037",
      "poi_longitude": "-95.8031131",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-376-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-067a-7495-a9e3-8622cedbf612",
        "storage_key": "property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZaMFkb3tocRCAsWchfg8iA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f747b4c-d5b9-40ca-bddf-34d3fa032f99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Rayola Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8300 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Park with a playground and splash pad, plus a walking trail, picnic tables, and pavilion.",
      "poi_long_description": "People say this park offers a playground, splash pad, pickleball courts, pavilion, and walking trail. They highlight the large playground, the peaceful walking trail, and the ample green space. They also like the fenced-in playground area and the open restrooms. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-ff35-712c-9245-bcc7e94a1bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-ff35-712c-9245-bcc7e94a1bff",
        "storage_key": "property/6767906449165603/019cfb3f-ff35-712c-9245-bcc7e94a1bff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046342745985045140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rayola-park",
      "poi_latitude": "36.2713222",
      "poi_longitude": "-95.84879920000002",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-376-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-067a-7495-a9e3-8622cedbf612",
        "storage_key": "property/6767906449165603/019cfb40-067a-7495-a9e3-8622cedbf612.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZoluY_wtocRlNJOpf01CEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0800834f-f74d-4049-8a68-e16cb44ce92a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Gundys",
      "poi_type": "Transportation & Transit",
      "poi_address": "7806 N 172nd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0092-75d1-b6d2-15ecebd016f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb40-0092-75d1-b6d2-15ecebd016f1",
        "storage_key": "property/6767906449165603/019cfb40-0092-75d1-b6d2-15ecebd016f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gundysairport.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4107118366967304947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gundys",
      "poi_latitude": "36.2670849",
      "poi_longitude": "-95.7841404",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-272-1523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0977-7575-8e6e-6172eaa25f0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0977-7575-8e6e-6172eaa25f0b",
        "storage_key": "property/6767906449165603/019cfb40-0977-7575-8e6e-6172eaa25f0b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRmOtxH3tocR85KR8WRq_zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1dcb2994-5af0-41b7-8a4a-71f2a2508c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Airman Acres Airport-OK93",
      "poi_type": "Transportation & Transit",
      "poi_address": "E 126th St N, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0117-771a-82f4-db34533f745c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb40-0117-771a-82f4-db34533f745c",
        "storage_key": "property/6767906449165603/019cfb40-0117-771a-82f4-db34533f745c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14842558028454321639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airman-acres-airport-ok93",
      "poi_latitude": "36.3351884",
      "poi_longitude": "-95.8927046",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-371-2014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0977-7575-8e6e-6172eaa25f0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0977-7575-8e6e-6172eaa25f0b",
        "storage_key": "property/6767906449165603/019cfb40-0977-7575-8e6e-6172eaa25f0b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyvsHZ35tocR510kPONb-80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_67dd6e32-e547-4adf-81cb-3f055c543f35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Verizon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 N Lakewood Ave, Tulsa, OK 74117, USA",
      "poi_short_description": "Telecommunications company offering cell phones, wireless plans, accessories & more.",
      "poi_long_description": "Telecommunications company offering cell phones, wireless plans, accessories & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0142-77ea-b933-5b88392d352c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb40-0142-77ea-b933-5b88392d352c",
        "storage_key": "property/6767906449165603/019cfb40-0142-77ea-b933-5b88392d352c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.verizonwireless.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8994536342959291733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "verizon",
      "poi_latitude": "36.2548751",
      "poi_longitude": "-95.904602",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-590-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF26cn9HvtocRVf1tGSYD03w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b4561df0-9e0d-49a0-bf50-fdca659617ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "City of Owasso",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-01bf-71ad-a82f-13426b1d5122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb40-01bf-71ad-a82f-13426b1d5122",
        "storage_key": "property/6767906449165603/019cfb40-01bf-71ad-a82f-13426b1d5122.webp",
        "width": 601,
        "height": 290
      },
      "poi_business_url": "https://www.cityofowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16667434515310460285&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-owasso",
      "poi_latitude": "36.2637562",
      "poi_longitude": "-95.8555663",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-376-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0ab8-751b-9537-058deded6bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0ab8-751b-9537-058deded6bbd",
        "storage_key": "property/6767906449165603/019cfb40-0ab8-751b-9537-058deded6bbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydO3w_XwtocRfT0qQmKfTuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_883ba99c-2b1c-4602-b5b3-017409c82344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Legacy Living",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12150 E 96th St N Suite 200, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-028f-744f-bfe3-80605eda6c91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb40-028f-744f-bfe3-80605eda6c91",
        "storage_key": "property/6767906449165603/019cfb40-028f-744f-bfe3-80605eda6c91.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.legacysl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17704443287973334600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-living",
      "poi_latitude": "36.2914006",
      "poi_longitude": "-95.8382875",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQR0-J7wtocRSA6zRV7RsvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f8b51d8-8e41-4a6a-b48d-1e9566e64e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "The Goddard School of Owasso",
      "poi_type": "Education",
      "poi_address": "14600 E 89th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Private preschool offering programs to nurture children's curiosity in a safe environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-3081-734d-8208-62dc15c4bf25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3081-734d-8208-62dc15c4bf25",
        "storage_key": "property/6767906449165603/019d7912-3081-734d-8208-62dc15c4bf25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ok/owasso/owasso?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=15901176915256238191&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-goddard-school-of-owasso",
      "poi_latitude": "36.28246",
      "poi_longitude": "-95.810959",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-1514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcQ11u033tocRb2B9CChUrNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_83d0fda2-4732-419f-9392-b5a5afeb6c36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Northeast Elementary",
      "poi_type": "Education",
      "poi_address": "13650 East 103rd St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northeast.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12376512762987088512&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeast-elementary",
      "poi_latitude": "36.30094700000001",
      "poi_longitude": "-95.8203936",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-272-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydiJaQL6tocRgArvy8g0wqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_723669d3-8245-4517-a730-a29d360c5825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Rejoice Christian School",
      "poi_type": "Education",
      "poi_address": "13407 E 106th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-358e-73fc-9137-5ff1d7ed99bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-358e-73fc-9137-5ff1d7ed99bd",
        "storage_key": "property/6767906449165603/019d7912-358e-73fc-9137-5ff1d7ed99bd.webp",
        "width": 1280,
        "height": 460
      },
      "poi_business_url": "http://www.rejoiceschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12487743676581848759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rejoice-christian-school",
      "poi_latitude": "36.3107571",
      "poi_longitude": "-95.825138",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-516-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-OPPBH6tocRt6bKALZgTa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5e168cd2-fda1-4d6d-b899-ac409fc3b5b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso 6th Grade Center",
      "poi_type": "Education",
      "poi_address": "8101 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-2f86-70bb-b968-c060c6b4f036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2f86-70bb-b968-c060c6b4f036",
        "storage_key": "property/6767906449165603/019d7912-2f86-70bb-b968-c060c6b4f036.webp",
        "width": 720,
        "height": 467
      },
      "poi_business_url": "https://6gc.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11584026575099376736&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-6th-grade-center",
      "poi_latitude": "36.2722599",
      "poi_longitude": "-95.8287218",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVZTV0r7wtocRYLR7lcu6wqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c0d2e4f2-c22b-4876-ba25-557d6ee45b42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso 7th Grade Center",
      "poi_type": "Education",
      "poi_address": "1400 N Main St, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-30b9-715c-af73-02e561eee2a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-30b9-715c-af73-02e561eee2a1",
        "storage_key": "property/6767906449165603/019d7912-30b9-715c-af73-02e561eee2a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://7gc.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7377164253107038371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-7th-grade-center",
      "poi_latitude": "36.2801573",
      "poi_longitude": "-95.855497",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-1183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3bukk4nwtocRo6gnZM3zYGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eb7ca7c5-2463-4b61-bce6-cb0c17ee4b63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso 8th Grade Center",
      "poi_type": "Education",
      "poi_address": "13901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://8gc.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15438888320843168054&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-8th-grade-center",
      "poi_latitude": "36.2813683",
      "poi_longitude": "-95.8228405",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-6274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDccqD7TwtocRNrnICiHzQdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_820de6a6-1169-4c6a-8108-24a9ec616039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "9341 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://owassoprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17717246513680442630&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-preparatory-academy",
      "poi_latitude": "36.2910614",
      "poi_longitude": "-95.829034",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-378-0344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvXr7DqP7tocRBmXzjdVN4PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_bc174951-c90c-4b3c-b45d-7a740153f2a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso High School Track",
      "poi_type": "Education",
      "poi_address": "12901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-3a7b-7347-8011-7ff41887f947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a7b-7347-8011-7ff41887f947",
        "storage_key": "property/6767906449165603/019d7912-3a7b-7347-8011-7ff41887f947.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18359467082622835272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-high-school-track",
      "poi_latitude": "36.2812035",
      "poi_longitude": "-95.826348",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-1867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU9Lqw7vwtocRSBo2_Qnuyf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c1480b34-3e9a-4af5-b0f3-bec573ddea87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Tulsa Tech - Owasso Campus",
      "poi_type": "Education",
      "poi_address": "10800 N 137th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-39cc-7271-a62a-95b1a6c48153.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-39cc-7271-a62a-95b1a6c48153",
        "storage_key": "property/6767906449165603/019d7912-39cc-7271-a62a-95b1a6c48153.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tulsatech.edu/?utm_source=google+my+business&utm_medium=search&utm_campaign=OWA&utm_id=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=6700207397830656391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-tech-owasso-campus",
      "poi_latitude": "36.3130104",
      "poi_longitude": "-95.8184926",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-828-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0679-71cc-aa5e-bc3a1339dfa3",
        "storage_key": "property/6767906449165603/019cfb40-0679-71cc-aa5e-bc3a1339dfa3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu7dz1hj6tocRhwEkDSHr-1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_418fd832-a59a-4aaa-abe7-23c17ff1b387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Hawaiian Bros Island Grill",
      "poi_type": "Restaurants",
      "poi_address": "11602 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Hawaiian-style comfort dishes such as chicken and pork served in a casual restaurant with a drive-thru.",
      "poi_long_description": "People say this Hawaiian restaurant serves tender and flavorful chicken, and delicious macaroni salad with a unique flavor. They highlight the fast and friendly service, and the generous portions. They also like the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-4699-76db-89b8-507f2d07dad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4699-76db-89b8-507f2d07dad9",
        "storage_key": "property/6767906449165603/019d7912-4699-76db-89b8-507f2d07dad9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://hawaiianbros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10269515012742632471&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hawaiian-bros-island-grill",
      "poi_latitude": "36.2924741",
      "poi_longitude": "-95.8431642",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-716-1181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD26VXMzxtocRF9QQbn6lhI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_df59bac6-d3dd-4ef7-a1bf-0fac74aa4c6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Waldo's Chicken & Beer",
      "poi_type": "Restaurants",
      "poi_address": "9140 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Casual restaurant specializing in Southern-style fare and featuring fried chicken and a full bar.",
      "poi_long_description": "People say this chicken restaurant serves phenomenal fried chicken, creamy mac n' cheese, and delicious cheddar biscuits. They also highlight the fresh, flavorful food, the wide selection of sauces, and the fun, humorous decor.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-431a-7774-9e7e-82ab0f4a15df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-431a-7774-9e7e-82ab0f4a15df",
        "storage_key": "property/6767906449165603/019d7912-431a-7774-9e7e-82ab0f4a15df.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://waldoschicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=174832998732867194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waldo-s-chicken-beer",
      "poi_latitude": "36.2915798",
      "poi_longitude": "-95.8402797",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-928-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXX_PQDxtocReiZ9oK8hbQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_8cda63e0-68df-4417-af95-db005f8e712d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "12903 E 96th St N A, Owasso, OK 74055, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves tasty pizza with a variety of toppings, as well as fried mushrooms, wings, and salads. They highlight the half-price drinks during happy hour and the quick service. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-456f-73bd-af32-40616088b34e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-456f-73bd-af32-40616088b34e",
        "storage_key": "property/6767906449165603/019d7912-456f-73bd-af32-40616088b34e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8117728085082139184&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "36.2934902",
      "poi_longitude": "-95.8287993",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-928-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8N2R6fwtocRMGqIDq_2p3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_587fb893-7cdf-4d3f-87ad-cdb3ee871bbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Smitty's Garage Burgers and Beer",
      "poi_type": "Restaurants",
      "poi_address": "13303 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Casual chain serving burgers, chili dogs, and small plates, plus sports on TV.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including the sticky finger burger, BBQ Bacon Zeta burger, and Sweet Oklahoma burger. They also highlight the fresh-cut fries, fun atmosphere, and friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-4851-7429-a7b8-b7d9150f6077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4851-7429-a7b8-b7d9150f6077",
        "storage_key": "property/6767906449165603/019d7912-4851-7429-a7b8-b7d9150f6077.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://www.eatatthegarage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8378552242977023954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smitty-s-garage-burgers-and-beer",
      "poi_latitude": "36.2936545",
      "poi_longitude": "-95.826046",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-376-6121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xVe6qfwtocR0qeynt-YRnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e675adf4-4108-4bbe-a686-a3b5499d526a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Goldie's Patio Grill",
      "poi_type": "Restaurants",
      "poi_address": "8591 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Unassuming eatery serving burgers, fried chicken & other American comfort food.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, fries, and chicken fried steak. They also highlight the friendly and helpful staff, and the enjoyable bread and butter, and pickle bar.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-4e08-721b-87e7-861abb827abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4e08-721b-87e7-861abb827abe",
        "storage_key": "property/6767906449165603/019d7912-4e08-721b-87e7-861abb827abe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goldies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10761363373035698808&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "goldie-s-patio-grill",
      "poi_latitude": "36.2774559",
      "poi_longitude": "-95.84598",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-8501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4by52ZHwtocReDqxvPgKWJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a1237110-c563-4592-8ee4-188abc9a6492",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Los Cabos Mexican Grill and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "9455 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Mexican classics in upscale, relaxed environs with outdoor live music & weekend mariachi bands.",
      "poi_long_description": "People say this Mexican restaurant serves delicious brisket tacos, tamales, and enchiladas. They also highlight the fresh guacamole, tasty salsa, and great margaritas.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-5743-72a7-ad65-6e91a86bcd32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5743-72a7-ad65-6e91a86bcd32",
        "storage_key": "property/6767906449165603/019d7912-5743-72a7-ad65-6e91a86bcd32.webp",
        "width": 1280,
        "height": 1050
      },
      "poi_business_url": "http://www.loscabosok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14944752830916294454&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-cabos-mexican-grill-and-cantina",
      "poi_latitude": "36.29050600000001",
      "poi_longitude": "-95.83542",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-609-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ27iQp_wtocRNnfH3oRtZs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e2343310-4819-4f3b-9c51-0586a1f55f3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "SMOKE Woodfire Grill",
      "poi_type": "Restaurants",
      "poi_address": "201 S Main St #100, Owasso, OK 74055, USA",
      "poi_short_description": "Wood-fired grill-prepared fare, wine, steak and cocktails served in a relaxed space with a cigar lounge.",
      "poi_long_description": "People say this American restaurant serves delicious pork chops, lamb sliders, and salmon. They also highlight the warm and inviting atmosphere, and the attentive and friendly service.\n\nOther reviews mention the menu can change frequently.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-5f8c-770b-9451-a440b55a13ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5f8c-770b-9451-a440b55a13ea",
        "storage_key": "property/6767906449165603/019d7912-5f8c-770b-9451-a440b55a13ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://smokewoodfiregrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7366559326177376568&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smoke-woodfire-grill",
      "poi_latitude": "36.2638313",
      "poi_longitude": "-95.8547962",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-401-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVacSfbwtocROLmkba1GO2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_06e81385-6c76-458f-9ce7-eee827c17562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Kim’s Pho",
      "poi_type": "Restaurants",
      "poi_address": "12308 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Casual eatery dishing up Vietnamese fare, including beef pho, spring rolls, and curries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-5fc8-75cc-ad80-ddf9635c1119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5fc8-75cc-ad80-ddf9635c1119",
        "storage_key": "property/6767906449165603/019d7912-5fc8-75cc-ad80-ddf9635c1119.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4244338889774493945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kim-s-pho",
      "poi_latitude": "36.2775228",
      "poi_longitude": "-95.8364198",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-516-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVkj-fXxtocR-XBil7vr5jo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_8576b0aa-9f6d-4dbb-b098-a32da3688393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Andolini's Pizzeria Owasso",
      "poi_type": "Restaurants",
      "poi_address": "12140 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Italian dishes & specialty pizzas cooked up with homemade mozzarella cheese in a bustling locale.",
      "poi_long_description": "People say this Italian restaurant serves delicious pizza, garlic knots, and gelato. They highlight the generous portions, fresh ingredients, and the availability of gluten-free and vegan options. They also like the friendly staff and outstanding service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-6b48-743b-8b24-e8cc721db0eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6b48-743b-8b24-e8cc721db0eb",
        "storage_key": "property/6767906449165603/019d7912-6b48-743b-8b24-e8cc721db0eb.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://andopizza.com/location/owasso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15340483108004874810&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andolini-s-pizzeria-owasso",
      "poi_latitude": "36.2923588",
      "poi_longitude": "-95.8388988",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-272-9328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ7cTJ7wtocROsqC_xtY5NQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_fa120b5f-bab4-4211-82a7-3b1b08d3201c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "11909 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Local brewpub chain serving burgers, pizza, American comfort food & beer in a brick-walled space.",
      "poi_long_description": "People say this American restaurant serves delicious dishes like the soy-glazed salmon, chopped and chipped nachos, and shrimp mango tacos. They highlight the good food, great beer choices, and fun atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-70b5-729f-b806-53bf06ceda43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-70b5-729f-b806-53bf06ceda43",
        "storage_key": "property/6767906449165603/019d7912-70b5-729f-b806-53bf06ceda43.webp",
        "width": 823,
        "height": 1280
      },
      "poi_business_url": "https://bricktownbrewery.com/location/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=9149037493883191025&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "36.2934651",
      "poi_longitude": "-95.8410255",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-321-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dZu-53wtocR8T6jgyDp934",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e76c0e41-0766-445d-9529-ea858c2a4730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9072 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious breadsticks, salad, and Alfredo sauce, and they praise the unlimited soup, salad, and breadsticks. They also highlight the friendly and attentive service, and the peaceful atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-7c39-742e-83e6-1a41a4cb84f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7c39-742e-83e6-1a41a4cb84f1",
        "storage_key": "property/6767906449165603/019d7912-7c39-742e-83e6-1a41a4cb84f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/owasso/owasso/1778?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:owasso-ok-1778_pl:locurl_rd:1625",
      "poi_directions_map_url": "https://maps.google.com/?cid=10788694414358487658&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.292518",
      "poi_longitude": "-95.839812",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-1436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExXEOpzwtocRaiIUrmgkuZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f8b771d8-cc7a-4159-9657-f0f1ec132740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Trails End Barbecue & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8888 N Garnett Rd, Owasso, OK 74055, USA",
      "poi_short_description": "Wood-smoked pork, chicken & more served in a down-to-earth setting with a rustic, country vibe.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and turkey, and offers complimentary cobbler. They highlight the generous portions, reasonable prices, and casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-7b79-7606-bd0e-bce50534a7e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7b79-7606-bd0e-bce50534a7e1",
        "storage_key": "property/6767906449165603/019d7912-7b79-7606-bd0e-bce50534a7e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.trailsendbbq.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4438774694451998559&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trails-end-barbecue-grill",
      "poi_latitude": "36.281271",
      "poi_longitude": "-95.8489",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0686-711c-a34c-0ee3be6c9366",
        "storage_key": "property/6767906449165603/019cfb40-0686-711c-a34c-0ee3be6c9366.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYmBC4_wtocRX-_NJBGymT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_c637fe67-8472-4eed-9513-2bc2d71b4a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "8959 N Garnett Rd, Owasso, OK 74055, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of fishing gear and clearance fishing clothes. They also highlight the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-76b6-7669-b141-e1d2291e7b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-76b6-7669-b141-e1d2291e7b47",
        "storage_key": "property/6767906449165603/019d7912-76b6-7669-b141-e1d2291e7b47.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/owasso/store-0244",
      "poi_directions_map_url": "https://maps.google.com/?cid=16727263850299031197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "36.2853677",
      "poi_longitude": "-95.84637080000002",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-295-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPdPo8ILwtocRnX5O1dgtI-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_cab22651-5240-45fd-951c-adc8e17ea6ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Home Services at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9450 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-7ea7-77d0-aff0-577632900aa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ea7-77d0-aff0-577632900aa9",
        "storage_key": "property/6767906449165603/019d7912-7ea7-77d0-aff0-577632900aa9.webp",
        "width": 1280,
        "height": 685
      },
      "poi_business_url": "https://www.homedepot.com/l/Owasso/OK/Owasso/74055/8922/services?emt=HSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493575664102125137&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "home-services-at-the-home-depot",
      "poi_latitude": "36.2899203",
      "poi_longitude": "-95.8318248",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 844-476-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3ZvbKHwtocRUa4NuEaGI8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_1148e64e-a8c3-4ee5-8f97-1e77374cca56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12912 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-88e1-7398-aefc-6ba0d0dc9e3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-88e1-7398-aefc-6ba0d0dc9e3d",
        "storage_key": "property/6767906449165603/019d7912-88e1-7398-aefc-6ba0d0dc9e3d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13557807012906726814&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-town-center",
      "poi_latitude": "36.2766119",
      "poi_longitude": "-95.8288634",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-524-3833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ86Ke_7vwtocRnvWaWaUBJ7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a06b101c-3a6b-4b14-af07-03de4358813a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "SEVEN6MAIN",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-8e6d-746a-aa43-9b8e4fac3375.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8e6d-746a-aa43-9b8e4fac3375",
        "storage_key": "property/6767906449165603/019d7912-8e6d-746a-aa43-9b8e4fac3375.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "https://www.seven6main.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8566228115422496859&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "seven6main",
      "poi_latitude": "36.2638313",
      "poi_longitude": "-95.8547962",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-6586",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-06ab-730d-a349-117356912ffc",
        "storage_key": "property/6767906449165603/019cfb40-06ab-730d-a349-117356912ffc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW662mxvxtocRW8i4zBVb4XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f2373826-9710-4361-8910-66d8da5175c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Lanes At Coffee Creek",
      "poi_type": "Entertainment",
      "poi_address": "10301 Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Family-friendly bowling facility offering leagues, plus an arcade.",
      "poi_long_description": "People say this bowling alley offers fun and affordable bowling. They also highlight the clean facilities and good prices.\n\nOther reviews mention the lanes can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-96c8-763c-8d9f-8ce7f0a45769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-96c8-763c-8d9f-8ce7f0a45769",
        "storage_key": "property/6767906449165603/019d7912-96c8-763c-8d9f-8ce7f0a45769.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.owassobowling.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16284624386041981842&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lanes-at-coffee-creek",
      "poi_latitude": "36.3037513",
      "poi_longitude": "-95.8212953",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-274-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWzp_6DwtocRkiuydpmb_uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_8c3399f3-6492-45cf-b819-ab74d60fb523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Wheels and Thrills",
      "poi_type": "Entertainment",
      "poi_address": "10637 N Garnett Rd, Owasso, OK 74055, USA",
      "poi_short_description": "Kids' amusement center offering roller skating, laser tag, arcade games and a play zone for youngsters.",
      "poi_long_description": "People say this roller skating rink offers fun skating, laser tag, and a play zone. They highlight the reasonable prices, all-day skating, and unlimited laser tag, as well as the fresh food and generous portions. They also like the engaging staff and the clean, safe environment, especially during Tiny Tots events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-a95a-772d-93ad-2d82a1417042.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a95a-772d-93ad-2d82a1417042",
        "storage_key": "property/6767906449165603/019d7912-a95a-772d-93ad-2d82a1417042.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wheelsandthrills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7585723562815473111&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wheels-and-thrills",
      "poi_latitude": "36.3090667",
      "poi_longitude": "-95.8472061",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-7537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQ29o2f6tocR10XttWPnRWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_5481270d-47f6-4c04-9aea-ee496bafed39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Sports Park South",
      "poi_type": "Entertainment",
      "poi_address": "10319 E 106th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d7912-9b84-701e-94d1-33a2954bd25f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9b84-701e-94d1-33a2954bd25f",
        "storage_key": "property/6767906449165603/019d7912-9b84-701e-94d1-33a2954bd25f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofowasso.com/Facilities/Facility/Details/Sports-Park-South-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=14371446262690985792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-sports-park-south",
      "poi_latitude": "36.3090958",
      "poi_longitude": "-95.8602542",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxnQCYn6tocRQLdPlDuiccc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_3bd95fe5-c89e-41c6-b66f-0904874bc4ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Owasso Gathering on Main",
      "poi_type": "Entertainment",
      "poi_address": "12324 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://owassogathering.com/the-story/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7652057665989003690&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-gathering-on-main",
      "poi_latitude": "36.277533",
      "poi_longitude": "-95.8357546",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-0099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb40-0683-77b7-8d06-6f2bcea09fef",
        "storage_key": "property/6767906449165603/019cfb40-0683-77b7-8d06-6f2bcea09fef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWKSepbwtocRqkkUpueRMWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a1be7dae-295b-41da-8598-a0bd6ec685dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "poi_name": "Smith Farm Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "smith-farm-shopping-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7eab993be686c292ceafecb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b164bd9d9ea308e0ac73af0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c2be165efe410870db9adc3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_725de14e2fbd148a2116cea7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_68fbaa1c660ebe86a03247d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_b1dde79b89e778081f7fd2e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_722ccd283a098e5668f89e88",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "rating": "5",
      "name": "Jessica Haire",
      "text": "I love living at Cypress Crossing. I leased a unit sight unseen and have no regrets. The 3rd floor vaulted ceilings were a wonderful surprise and the entire apartment is much larger than I expected. We love to grill out by the pool and swim as often as possible. The community is safe, quiet, and beautiful.",
      "date": "2025-07-03",
      "title": "false"
    },
    {
      "id": "ec_01cc08d0d7a280775deec15b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "rating": "5",
      "name": "IDA Blackwell",
      "text": "We were part of the first wave to move here. We have been well taken care of and enjoy living here. The people here are so friendly and the pool is fantastic.",
      "date": "2025-07-29",
      "title": "false"
    },
    {
      "id": "ec_600718a056fb1cb757dbd113",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "rating": "5",
      "name": "Liz Reardon",
      "text": "We love this beautiful community already!\nThe on-site management especially Hailey and Kim have been so welcoming and always happy to help! The property is well maintained daily.\nThe availability of beverages and snacks goes over and above in main building! Gym is well equipped.\nWe have moved from a very large home to a 2 bedroom apartment everyone here has made such a big move bearable! 😊",
      "date": "2025-07-03",
      "title": "false"
    },
    {
      "id": "ec_a9e3bf089d5f94b598f7159f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "rating": "5",
      "name": "Clayton Weems",
      "text": "From the time we toured the complex, to the day we moved in, the staff have been extremely helpful and very responsive to all of our requests, questions and changes. Everything was clean and top notch. We did have very minor flaws when we moved in and one bigger one with one of the rooms not cooling. However Marcus the head growns person took care of them very quickly, politely and thoroughly. We are all moved and are very pleased with everything.",
      "date": "2025-08-16",
      "title": "false"
    },
    {
      "id": "ec_6176cd0adb8d26fa9b5dc558",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "rating": "5",
      "name": "Sad Cowboy Cat",
      "text": "This place is awesome! The management are great people very kind and good morals. The complex has a great pool and very nice, updated units. I also love the landscaping it’s very pretty to walk through and well kept.",
      "date": "2025-07-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a1a712f5-e287-4a31-8f51-b2ab0016258d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb41-46ae-758a-b804-db1542dc7c6a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the community kitchen and lounge area.",
        "public_id": "019cfb41-46ae-758a-b804-db1542dc7c6a",
        "storage_key": "property/6767906449165603/019cfb41-46ae-758a-b804-db1542dc7c6a.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cypress Crossing Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=688ad9b8c50057755492c21b&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-302a-73ea-add0-031e221f8839",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cypress-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603"
    },
    {
      "lead_collector_id": "019cf79e-309a-771d-86b2-84ff81e85779",
      "lead_source": "LANDING_PAGE",
      "name": "cypress-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "apartments-with-pools-owasso-ok",
      "search_query": "apartments with pools in Owasso OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Owasso, OK",
      "h2_subtitle": "Dive into relaxation at Cypress Crossing. Our Owasso apartments feature refreshing pools perfect for winding down or staying active.",
      "page_copy": "Discover the perfect blend of relaxation and comfort at Cypress Crossing, offering spacious one, two, or three-bedroom apartments with incredible amenities. Our beautiful pool area is a standout feature, providing the perfect spot to unwind under the sun or take a refreshing dip.\n\nNestled in North Tulsa, Cypress Crossing not only offers luxurious living spaces with modern touches like stainless steel appliances and walk-in closets but also ensures that leisure and fitness are a top priority. Whether you want to enjoy a leisurely swim or host a poolside gathering, our apartments with pools in Owasso, OK, cater to every lifestyle. Visit Cypress Crossing to find your ideal home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Owasso, OK",
      "seo_description": "Find modern apartments with pools in Owasso, OK, at Cypress Crossing. Enjoy luxurious amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-north-tulsa",
      "search_query": "pet-friendly apartments with dog park in North Tulsa",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in North Tulsa",
      "h2_subtitle": "Bring your furry friends to Cypress Crossing! Our North Tulsa community boasts a dedicated dog park for pets to enjoy.",
      "page_copy": "Cypress Crossing is the ultimate destination for pet owners seeking a welcoming environment in North Tulsa. Featuring a dedicated dog park, our pet-friendly apartments offer a perfect balance of convenience and comfort, ensuring both you and your furry companions feel right at home.\n\nChoose from our spacious one, two, or three-bedroom layouts equipped with modern amenities like high ceilings and walk-in closets. Your pets will love living here, thanks to our expansive, on-site dog park where they can run and play. Embrace a community that values your pets as much as you do at Cypress Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in North Tulsa",
      "seo_description": "Cypress Crossing offers pet-friendly apartments with a dog park in North Tulsa. Enjoy modern living with amenities for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-near-74055",
      "search_query": "luxury apartments with fitness center near 74055",
      "category": "Amenity",
      "h1_title": "Luxury Apartments Near 74055",
      "h2_subtitle": "Experience refined living in Owasso, OK. Our luxury apartments near 74055 boast a top-tier fitness center and upscale features.",
      "page_copy": "Step into a world of elegance and modern convenience at Cypress Crossing, where our luxury apartments near 74055 redefine sophisticated living. Each apartment is meticulously designed with features such as high ceilings, stainless steel appliances, and private balconies or patios.\n\nFitness enthusiasts will appreciate our state-of-the-art fitness center, equipped to support an active lifestyle. Located conveniently in North Tulsa, Cypress Crossing offers a serene setting without sacrificing accessibility to local attractions. Embrace luxury living with a focus on health and wellness at our exclusive community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near 74055",
      "seo_description": "Discover luxury apartments with a fitness center near 74055 at Cypress Crossing in Owasso. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "stainless-steel-appliances-owasso-apartments",
      "search_query": "stainless steel appliances in Owasso apartments",
      "category": "Amenity",
      "h1_title": "Owasso Apartments with Modern Kitchens",
      "h2_subtitle": "Explore Cypress Crossing for sleek kitchen designs in Owasso. Our apartments feature stainless steel appliances for a modern touch.",
      "page_copy": "At Cypress Crossing in Owasso, experience the perfect blend of style and function with our modern kitchens. Each apartment is equipped with sleek stainless steel appliances, offering both aesthetic appeal and high performance for all your culinary needs.\n\nLocated in the charming North Tulsa area, our one, two, and three-bedroom units provide a contemporary living experience with luxurious finishes and thoughtful amenities. From cooking gourmet meals to hosting dinner parties, these kitchens are designed to impress and cater to every resident's lifestyle. Visit Cypress Crossing to see the difference for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Kitchens in Owasso Apartments",
      "seo_description": "Find Owasso apartments with modern kitchens featuring stainless steel appliances at Cypress Crossing. Experience style and convenience in every corner.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "walk-in-closets-north-tulsa-apartments",
      "search_query": "walk-in closets in North Tulsa apartments",
      "category": "Amenity",
      "h1_title": "North Tulsa Apartments with Spacious Closets",
      "h2_subtitle": "Discover Cypress Crossing in North Tulsa, where spacious walk-in closets add a touch of luxury to our modern apartments.",
      "page_copy": "Cypress Crossing offers a refined living experience in North Tulsa with spacious walk-in closets that optimize storage while maintaining a sleek and organized look. Each of our one, two, or three-bedroom apartments is designed to cater to your lifestyle needs, providing ample room to arrange your wardrobe and store personal items conveniently.\n\nBeyond stylish interiors, our community features modern amenities such as a fitness center and dog park. Enjoy the best of both comfort and convenience at Cypress Crossing, where ample closet space meets modern apartment living, making it the perfect choice for those wanting extra storage without compromising on style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Tulsa Apartments with Walk-In Closets",
      "seo_description": "Explore North Tulsa apartments with spacious walk-in closets at Cypress Crossing. Enjoy luxury living with ample storage and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-owasso-ok",
      "search_query": "one bedroom apartments in Owasso OK",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Owasso, OK",
      "h2_subtitle": "Explore comfortable one-bedroom living at Cypress Crossing. Discover modern amenities in Owasso, OK, ideal for singles or couples.",
      "page_copy": "Discover the perfect blend of comfort and style with our one-bedroom apartments at Cypress Crossing in Owasso, OK. These thoughtfully designed spaces offer modern amenities, including stainless steel appliances and walk-in closets, ideal for singles or couples seeking a cozy retreat.\n\nNestled in the vibrant North Tulsa area, our community provides more than just a place to live. Take advantage of our high-speed internet, relax on your private balcony, or enjoy the on-site fitness center and dog park. Make Cypress Crossing your home, where convenience meets upscale living in the heart of Owasso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Owasso, OK",
      "seo_description": "Find one-bedroom apartments in Owasso, OK at Cypress Crossing. Enjoy modern amenities and a prime location perfect for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-north-tulsa",
      "search_query": "two bedroom apartments near North Tulsa",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments near North Tulsa",
      "h2_subtitle": "Cypress Crossing offers two-bedroom apartments perfect for families or roommates near North Tulsa. Featuring modern amenities and ample space.",
      "page_copy": "Situated near North Tulsa, Cypress Crossing presents spacious two-bedroom apartments perfect for families or roommates. These thoughtfully designed units feature modern comforts like stainless steel appliances and expansive walk-in closets, ensuring a stylish and functional living space.\n\nBeyond the practicality of generous bedrooms, our community provides residents with access to high-end amenities such as a fitness center, pool, and dog park. Additionally, each apartment includes a balcony or patio, allowing you to enjoy outdoor relaxation right at home. Choose Cypress Crossing for a convenient and contemporary lifestyle near North Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments near North Tulsa",
      "seo_description": "Explore two-bedroom apartments near North Tulsa at Cypress Crossing. Perfect for families, with modern amenities and ample living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165603",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-74055",
      "search_query": "three bedroom apartments 74055",
      "category": "Floorplan",
      "h1_title": "Spacious Three-Bedroom Apartments in 74055",
      "h2_subtitle": "Cypress Crossing offers three-bedroom apartments in the 74055 area, featuring luxurious amenities and ample living space.",
      "page_copy": "Experience enhanced living with the three-bedroom apartments available at Cypress Crossing in the 74055 area. These generously sized units provide the perfect blend of comfort and style, ideal for families seeking room to grow. Each apartment is equipped with modern amenities, including stainless steel appliances and expansive walk-in closets.\n\nOur community not only boasts spacious interiors but also offers residents a wealth of amenities such as a dog park, fitness center, and a relaxing pool area. Cypress Crossing is designed with families in mind, providing a perfect blend of convenience and luxury in the heart of Owasso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019cfb3f-e343-744f-ba62-fd23dacd6b13",
        "storage_key": "property/6767906449165603/019cfb3f-e343-744f-ba62-fd23dacd6b13.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments in 74055",
      "seo_description": "Discover three-bedroom apartments in the 74055 area at Cypress Crossing. Enjoy ample space and luxurious community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5172"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-1SM4X8NC6T"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151637"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cypress-crossing/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NCVRB7HQ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d1bd8-0a25-757c-9d0e-1550a4df1e6a.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "03169196-a0db-4a7c-bb4c-1aeb05e39017"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-560-7713"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "67a51e424bc33c73fab2c77a"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndwMFN2c3k4c3o0ZWExUlJ1M084VEE9PSIsInZhbHVlIjoiL3FRaStVY3RjZUUwc25xMmlNajJMQT09IiwibWFjIjoiMzM5OTgwYjU5YjI5MDYzN2FlMDE1NDc4NDhiM2M4YTg0Yzc4MzY5MmM1MjlhNzk4YmEzZjZhNDI1NDkzODU4YyJ9"
    }
  ],
  "custom_qb_id": "5172",
  "custom_ga4_id": "G-1SM4X8NC6T",
  "custom_repli_id": "10041151637",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cypress-crossing/register/",
  "custom_google_gtm_id": "GTM-NCVRB7HQ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d1bd8-0a25-757c-9d0e-1550a4df1e6a.webp",
  "custom_rentgrata_property_id": "03169196-a0db-4a7c-bb4c-1aeb05e39017",
  "custom_ppc_tracking_phone_number": "888-560-7713",
  "custom_residentboost_apartment_id": "67a51e424bc33c73fab2c77a",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndwMFN2c3k4c3o0ZWExUlJ1M084VEE9PSIsInZhbHVlIjoiL3FRaStVY3RjZUUwc25xMmlNajJMQT09IiwibWFjIjoiMzM5OTgwYjU5YjI5MDYzN2FlMDE1NDc4NDhiM2M4YTg0Yzc4MzY5MmM1MjlhNzk4YmEzZjZhNDI1NDkzODU4YyJ9"
};

export const generatedAt = '2026-08-27T21:38:22.119Z';
